export const de = {
  "gear.search": "Name oder Einheit suchen",
  "gear.sort": "Sortierung",
  "gear.sort.tier": "Rang zuerst",
  "gear.sort.power": "Modulstärke",
  "gear.sort.enhance": "Verstärkung",
  "gear.filters": "Bestand filtern",
  "gear.slot": "Modulplatz",
  "gear.tier": "Rang",
  "gear.maker": "Hersteller",
  "gear.owner": "Zuordnung",
  "gear.all": "Alle",
  "gear.free": "Im Depot",
  "gear.equipped": "Ausgerüstet",
  "gear.results": "{n} von {total} Modulen",
  "gear.reset": "Filter zurücksetzen",
  "gear.noMatch": "Keine Treffer. Ändere Suche oder Filter.",
  "gear.details": "Details & Verwaltung",
  "gear.pages": "Bestandsseiten",
  "gear.previous": "Zurück",
  "gear.next": "Weiter",
  "gear.filled": "{n} von 5 Plätzen belegt",
  "gear.slots": "Fünf Ausrüstungsplätze",
  "gear.empty": "Leer",
  "gear.emptySlot": "Dieser Platz ist frei",
  "gear.unitSections": "Einheitenbereiche",
  "gear.profile": "Profil & Ausbau",
  "gear.equipment": "Ausrüstung",
  "base.rotate": "Gebäude drehen",
  "base.openEvents": "Events öffnen",
  "base.openStore": "Store öffnen",
  "base.openVip": "VIP-Vorteile öffnen",
  "module.slot.drive": "Antrieb",
  "ui.navigation": "Hauptnavigation",
  "ui.galleryTitle": "Komponentengalerie",
  "ui.galleryHint": "Die echten Spielkomponenten mit Beispieldaten. Aktionen in dieser Galerie ändern weder ein Konto noch Vorräte oder Käufe.",
  "ui.language": "Sprache",
  "ui.reduced": "Bewegung reduzieren",
  "ui.tokens": "Farben und Gestaltung",
  "ui.spacing": "Abstände",
  "ui.type": "Schriftgrößen",
  "ui.radii": "Radien und Schatten",
  "ui.buttons": "Schaltflächen",
  "ui.button.default": "Standard",
  "ui.button.primary": "Primär",
  "ui.button.gold": "Premium",
  "ui.button.ghost": "Dezent",
  "ui.button.danger": "Gefahr",
  "ui.disabled": "Deaktiviert",
  "ui.buttonsHint": "Laden und Sperren verhindern Aktionen; Tastaturfokus bleibt sichtbar.",
  "ui.tabsBadges": "Tabs und Kennzeichen",
  "ui.ready": "Bereit",
  "ui.busy": "In Arbeit",
  "ui.locked": "Gesperrt",
  "ui.numbersTimers": "Zahlen, Mehrzahl und Timer",
  "ui.one": "Eine Aktivität",
  "ui.add": "+1.200",
  "ui.reset": "Zurücksetzen",
  "ui.progress": "Fortschritt und Kosten",
  "ui.units": "Einheiten: Rang, Sterne und Schaden",
  "ui.buildings": "Gebäudekarten",
  "ui.overlays": "Dialoge und Hinweise",
  "ui.modal": "Modaler Dialog",
  "ui.longTitle": "Langer Profiltitel",
  "ui.sheet": "Inspektionspanel",
  "ui.bottomSheet": "Modal von unten",
  "ui.tooltip": "Hinweis öffnen",
  "ui.tooltipText": "Dieser Hinweis erscheint bei Fokus, Berührung und Mauszeiger. Escape schließt ihn.",
  "ui.keyboardHint": "Escape schließt den Dialog. Modale Dialoge halten den Tastaturfokus; Inspektionspanels lassen die Basis bedienbar.",
  "ui.dialogText": "Dieses Fenster nutzt dieselbe Dialogkomponente wie die Storyanzeige und die Basispanels.",
  "ui.sampleName": "Beispielname",
  "ui.sampleAction": "Beispielaktion",
  "ui.offers": "Angebote: verfügbar, ausverkauft, nicht bezahlbar",
  "ui.feedback": "Benachrichtigungen und Belohnungen",
  "ui.sampleData": "Es werden Beispieldaten angezeigt.",
  "ui.errorExample": "Beispiel einer Fehlermeldung: Aktion fehlgeschlagen.",
  "ui.actionResult": "Beispielaktion ausgeführt. Kontodaten bleiben unverändert.",
  "ui.motionNavigation": "Bewegung und Navigation",
  "ui.playMotion": "Belohnungsflug zeigen",
  "ui.footer": "Die Galerie unterstützt die Sichtprüfung. Ein vollständiger Spieldurchlauf und echte Geräteprüfungen bleiben eigene Nachweise.",
  "story.enlarge": "Storybild vergrößern",
  "story.unavailable": "Das Storybild konnte nicht geladen werden.",
  "story.retry": "Bild erneut laden",
  "story.illustration": "Der abgebildete Trupp illustriert die Geschichte; im Kampf tritt deine gewählte Formation an.",
  "story.beforeAttack": "Erst beim Start des Angriffs werden {n} Treibstoff verbraucht.",
  "story.skipAttack": "Überspringen und angreifen",
  "siege.hint": "Halte die Basis Welle für Welle. Einheiten- und Mauerschaden bleiben erhalten; Bosswellen warten bei 10 und 20.",
  "siege.phase.intermission": "Zwischen den Wellen",
  "siege.phase.completed": "Belagerung überstanden",
  "siege.phase.defeated": "Verteidigung durchbrochen",
  "siege.phase.abandoned": "Belagerung beendet",
  "siege.phase.expired": "Event abgelaufen",
  "siege.survived": "{n} / {max} Wellen überstanden",
  "siege.points": "{n, plural, one {# Punkt} other {# Punkte}}",
  "siege.wall": "Mauer",
  "siege.reserved": "Diese Garnison bleibt für die Belagerung reserviert. Ihre Heimverteidigung bleibt aktiv. Eine Notfallreparatur stellt genau eine Einheit vollständig wieder her.",
  "siege.formationReserved": "Für eine laufende Belagerung reserviert. Aufstellung und Garnisonswechsel bleiben bis zum Ende gesperrt; Einheiten können weiterhin angesehen werden.",
  "siege.return": "Zur Event-Plaza",
  "siege.wrecked": "Wrack · 0% HP",
  "siege.repair": "Reparieren · {n} Credits",
  "siege.next": "Welle {n} starten",
  "siege.replay": "Wellen ansehen",
  "siege.abandon": "Belagerung beenden",
  "siege.abandonHint": "Bereits verdiente Punkte bleiben erhalten. Weitere Wellen sind in diesem Event danach nicht mehr möglich.",
  "siege.abandonConfirm": "Jetzt beenden und Garnison freigeben",
  "siege.history": "{n, plural, one {# gespielte Welle} other {# gespielte Wellen}}",
  "siege.wave": "Welle {n}",
  "siege.boss": "Boss",
  "siege.held": "Gehalten",
  "siege.lost": "Durchbrochen",
  "siege.rewards": "Deine erspielten Punkte und XP sind gespeichert. Erreichte Meilensteine kannst du in dieser Eventkarte abholen; Ranglistenbelohnungen kommen nach dem Event per Post.",
  "colony.collect": "Sammeln",
  "colony.production": "Bereit zur Abholung",
  "colony.pendingHint": "Produktion bleibt am Gebäude, bis du sie abholst. Lager und Gebäude teilen sich dieselbe Kapazität.",
  "colony.bubbleAt": "Goldmarkierung ab {n}",
  "colony.collectAll": "Alles sammeln",
  "colony.collectUnlock": "Freigeschaltet ab HQ 5 oder VIP 3.",
  "colony.morale": "Moral",
  "colony.population": "{n, plural, one {# Einwohner} other {# Einwohner}}",
  "colony.moraleHint": "Ab 80 Moral: +5% SCR und XP. Unter 30: −5%. Deine Aktionen bleiben immer verfügbar.",
  "colony.causes": "Was die Moral beeinflusst",
  "colony.standing": "Aktueller Grundwert: {n}",
  "colony.cause.foundation": "Gründung",
  "colony.cause.login": "Täglicher Besuch",
  "colony.cause.win": "Sieg",
  "colony.cause.loss": "Niederlage",
  "colony.cause.decorations": "Platzierte Gärten",
  "colony.cause.burning": "Aktiver Brand",
  "colony.gardens": "Koloniegärten",
  "colony.gardenHint": "Je Garten: +2 Moral, +0,5% Produktion und +1% XP. Belegt ein freies Feld. Entfernen erstattet keine Kosten.",
  "colony.gardenAdd": "Garten pflanzen · {n} SCR",
  "colony.garden": "Garten",
  "colony.removeGarden": "Entfernen",
  "colony.drill": "Täglicher Trainingsdrill",
  "colony.drillHint": "20 Sekunden, drei Versuche. Tippe jeweils im grünen Zeitfenster. Teilnahme: 1 XP-Modul, jeder Treffer: +1. Perfekt: +10 CDC.",
  "colony.drillStart": "Drill starten · 20 s",
  "colony.drillClaimed": "Heute abgeschlossen",
  "colony.drillAttempt": "Versuch {n} / 3",
  "colony.drillNow": "JETZT tippen",
  "colony.drillTap": "Auf Grün warten",
  "colony.drillMissed": "Verpasst · weiter",
  "colony.drillFinish": "Belohnung abholen",
  "colony.activity": "{n, plural, one {# Aktivität in der Kolonie} other {# Aktivitäten in der Kolonie}}",
  "colony.beacon.upgrade": "Upgrade bereit",
  "colony.beacon.collect": "Produktion abholen",
  "colony.beacon.freePull": "Kostenlose Fabrikation",
  "colony.beacon.repair": "Reparatur abgeschlossen",
  "colony.beacon.drill": "Täglicher Drill bereit",
  "units.xp.bonus": "Aktueller XP-Bonus: {n}% (Moral, Gärten, Forschung und Protokolle).",
  "store.loadFailed": "Die Angebote konnten nicht vollständig geladen werden. Bitte versuche es erneut.",
  "store.retry": "Erneut laden",
  "store.expired": "Abgelaufen",
  "units.xp.reviewHint": "Trainingsdaten wählen, Ergebnis prüfen und einmal anwenden. Zurücksetzen leert die Auswahl ohne Verbrauch.",
  "units.xp.quantity": "Anzahl der Module mit {n} XP",
  "units.xp.max": "Max. bis zum aktuellen Limit",
  "units.xp.reset": "Auswahl zurücksetzen",
  "units.xp.calculating": "Mengen und neue Werte werden berechnet…",
  "units.xp.preview": "Level {from} bis {to} · {xp} XP",
  "units.xp.noSelection": "Keine Module ausgewählt.",
  "units.xp.banked": "{n} überschüssige XP bleiben für eine spätere Erhöhung des Limits gespeichert.",
  "units.xp.apply": "Geprüfte Menge anwenden",
  "units.xp.milestone": "Meilenstein erreicht · Level {n}",
  "units.xp.levelUp": "Levelaufstieg! Level {n}",
  "units.xp.applied": "{xp} XP angewendet",
  "units.compare.title": "Ausrüstung vergleichen",
  "units.compare.action": "Vergleichen",
  "units.compare.stat": "Wert",
  "units.compare.current": "Aktuell",
  "units.compare.after": "Danach",
  "units.compare.change": "Änderung",
  "units.compare.replaces": "Ersetzt {name}; das alte Modul kehrt ins Depot zurück.",
  "units.compare.empty": "Belegt einen freien Modulplatz.",
  "units.compare.currentSets": "Aktuelle Sets",
  "units.compare.afterSets": "Sets nach Ausrüstung",
  "units.compare.transfer": "Abgebende Einheit: {name}",
  "units.compare.free": "Ausrüsten ist kostenlos. Vor der Bestätigung ändert sich nichts.",
  "units.compare.equip": "Geprüftes Modul ausrüsten",
  "units.compare.target": "Zieleinheit",
  "units.compare.stat.power": "Stärke",
  "units.compare.stat.hp": "HP",
  "units.compare.stat.atk": "ATK",
  "units.compare.stat.def": "DEF",
  "units.compare.stat.intervalTicks": "Angriffsintervall",
  "units.compare.stat.crit": "Krit-Chance",
  "units.compare.stat.critDmg": "Krit-Schaden",
  "units.compare.stat.acc": "Präzision",
  "units.compare.stat.eva": "Ausweichen",
  "units.compare.stat.energyPerAttack": "Energie / Angriff",
  "units.compare.stat.cargo": "Fracht",
  "units.compare.effect.hpPct": "HP",
  "units.compare.effect.speedPct": "Angriffstempo",
  "units.compare.effect.critPct": "Krit-Chance",
  "units.compare.effect.auraPct": "Aurastärke",
  "units.compare.effect.dmgVsShieldedPct": "Schaden gegen Schilde",
  "base.residentsUnavailable": "Die Bewohner konnten nicht geladen werden. Bitte lade die Ansicht erneut.",
  "app.name": "ZEnd",
  "app.tagline": "Eine Minute. Ein Credit. Keine Gnade.",
  "auth.login": "Anmelden",
  "auth.register": "Konto erstellen",
  "auth.name": "Name",
  "auth.password": "Passwort",
  "auth.password.confirm": "Passwort wiederholen",
  "auth.password.mismatch": "Die Passwörter stimmen nicht überein.",
  "auth.name.hint": "3–20 Zeichen: Buchstaben, Ziffern, Unterstrich",
  "auth.password.hint": "Mindestens 8 Zeichen",
  "auth.noAccount": "Noch kein Kommandant?",
  "auth.haveAccount": "Schon ein Konto?",
  "auth.submitting": "Einen Moment …",
  "auth.logout": "Abmelden",
  "auth.logoutAll": "Überall abmelden",
  "auth.mustChange": "Bitte ändere dein Startpasswort.",
  "auth.invite": "Einladungscode",
  "auth.invite.hint": "Dieser Server ist auf Einladung: Frag einen Spieler, der schon dabei ist.",
  "auth.error.INVITE_REQUIRED": "Ohne Einladungscode geht es hier nicht weiter.",
  "auth.error.INVITE_INVALID": "Diesen Einladungscode gibt es nicht.",
  "auth.error.INVITE_USED": "Dieser Einladungscode wurde schon eingelöst.",
  "auth.error.NAME_TAKEN": "Dieser Name ist schon vergeben.",
  "auth.error.UNAUTHORIZED": "Name oder Passwort stimmt nicht.",
  "auth.error.VALIDATION": "Bitte prüfe deine Eingaben.",
  "auth.error.generic": "Das hat nicht geklappt. Versuch es noch einmal.",
  "hud.credits": "{n, plural, one {# Credit} other {# Credits}}",
  "hud.credits.next": "Nächster Credit in {s}s",
  "hud.vip": "VIP {level}",
  "hud.megavip": "MegaVIP {rank}",
  "hud.day": "Tag {day}",
  "nav.base": "Basis",
  "nav.map": "Karte",
  "nav.units": "Einheiten",
  "nav.store": "Store",
  "nav.events": "Events",
  "nav.chat": "Chat",
  "nav.settings": "Einstellungen",
  "nav.alliance": "Allianz",
  "alliance.tab.overview": "Übersicht",
  "alliance.tab.members": "Mitglieder",
  "alliance.tab.requests": "Anfragen",
  "alliance.tab.log": "Protokoll",
  "alliance.tab.contribute": "Beitragen",
  "alliance.tab.buildings": "Gebäude",
  "alliance.tab.shop": "Shop",
  "alliance.tab.gifts": "Geschenke",
  "alliance.tab.diplomacy": "Diplomatie",
  "alliance.tab.events": "Duell",
  "alliance.duel.title": "Allianz-Duell",
  "alliance.duel.hint": "Montag bis Freitag: Allianzen werden nach Kraft gepaart; jeder Punkt eines Mitglieds zählt für die Allianz, Quellen des Wochenthemas doppelt. Meilensteine bringen Geschenke, die Sieger eine Truhe und Allianz-XP.",
  "alliance.duel.none": "Gerade kein Duell. Das nächste startet Montag 00:00; Allianzen, die dann bestehen, werden gepaart.",
  "alliance.duel.theme": "Wochenthema",
  "alliance.duel.theme.build": "Bau und Forschung",
  "alliance.duel.theme.units": "Einheiten",
  "alliance.duel.theme.kills": "Abschüsse",
  "alliance.duel.theme.gather": "Sammeln",
  "alliance.duel.theme.all": "Allround",
  "alliance.duel.target": "Ziel {n} Punkte (kein Gegner diese Woche)",
  "alliance.duel.contribution": "Dein Beitrag: {n} Punkte",
  "alliance.duel.milestones": "Meilensteine",
  "alliance.duel.milestone": "{pct} % · {n} Punkte",
  "alliance.duel.ends": "Endet in {t}",
  "alliance.duel.won": "Gewonnen · Truhe per Post, Allianz-XP gutgeschrieben",
  "alliance.duel.lost": "Verloren · nächste Woche wieder",
  "alliance.duel.draw": "Unentschieden",
  "alliance.log.duel": "Duell: {event}",
  "alliance.relation.neutral": "Neutral",
  "alliance.relation.allied": "Verbündet",
  "alliance.relation.hostile": "Feindlich",
  "alliance.relation.war": "Krieg",
  "alliance.relation.own": "Eigene Allianz",
  "alliance.diplomacy.title": "Beziehungen",
  "alliance.diplomacy.hint": "Kein Krieg kommt überraschend: Feindschaft ist sofort sichtbar, ein Krieg braucht 24 h Feindschaft oder drei Überfälle und beginnt nach 12 h Vorlauf. Verbündete können sich nicht überfallen; Bauhilfe unter Verbündeten zählt doppelt.",
  "alliance.diplomacy.none": "Keine Beziehungen. Suche eine Allianz, um ein Bündnis vorzuschlagen oder Feindschaft zu erklären.",
  "alliance.diplomacy.embassyHint": "Vorschläge (Bündnis, Frieden) brauchen die Botschaft auf Stufe 1. Feindschaft und Krieg gehen auch ohne.",
  "alliance.diplomacy.officersOnly": "Nur Offiziere und die Leitung handeln; du siehst den Stand.",
  "alliance.diplomacy.search": "Allianz suchen (Name oder Kürzel)",
  "alliance.diplomacy.propose": "Bündnis vorschlagen",
  "alliance.diplomacy.peace": "Frieden vorschlagen",
  "alliance.diplomacy.hostile": "Feindschaft erklären",
  "alliance.diplomacy.neutral": "Neutral werden",
  "alliance.diplomacy.dissolve": "Bündnis lösen (24 h)",
  "alliance.diplomacy.war": "Krieg erklären",
  "alliance.diplomacy.surrender": "Kapitulieren",
  "alliance.diplomacy.breaking": "Bündnis wird gelöst · noch {t}",
  "alliance.diplomacy.countdown": "Krieg beginnt in {t}",
  "alliance.diplomacy.warUntil": "Krieg · noch {t}",
  "alliance.diplomacy.score": "Kriegspunkte {mine} : {theirs}",
  "alliance.diplomacy.neutralAt": "Neutral möglich in {t}",
  "alliance.diplomacy.gateHostile": "Krieg möglich in {t}",
  "alliance.diplomacy.gateRaids": "Überfälle auf uns (24 h): {n}/{max}",
  "alliance.diplomacy.gateOpen": "Kriegserklärung möglich",
  "alliance.diplomacy.proposals": "Vorschläge",
  "alliance.diplomacy.incoming": "Eingehend",
  "alliance.diplomacy.outgoing": "Ausgehend",
  "alliance.diplomacy.noProposals": "Keine offenen Vorschläge.",
  "alliance.diplomacy.proposalAlliance": "Bündnis-Vorschlag",
  "alliance.diplomacy.proposalPeace": "Friedens-Vorschlag",
  "alliance.diplomacy.from": "von {name} [{tag}] · {by}",
  "alliance.diplomacy.to": "an {name} [{tag}]",
  "alliance.diplomacy.expires": "läuft ab in {t}",
  "alliance.diplomacy.history": "Verlauf",
  "alliance.diplomacy.noHistory": "Noch nichts geschehen.",
  "alliance.diplomacy.event.proposal": "Vorschlag ({kind}) mit {name} [{tag}]",
  "alliance.diplomacy.event.declined": "Vorschlag abgelehnt · {name} [{tag}]",
  "alliance.diplomacy.event.expired": "Vorschlag verfallen · {name} [{tag}]",
  "alliance.diplomacy.event.allied": "Bündnis mit {name} [{tag}] geschlossen",
  "alliance.diplomacy.event.breaking": "Bündnis mit {name} [{tag}] wird gelöst",
  "alliance.diplomacy.event.neutral": "Wieder neutral zu {name} [{tag}]",
  "alliance.diplomacy.event.hostile": "Feindschaft mit {name} [{tag}]",
  "alliance.diplomacy.event.war_declared": "Krieg gegen {name} [{tag}] erklärt",
  "alliance.diplomacy.event.war": "Krieg gegen {name} [{tag}] begonnen",
  "alliance.diplomacy.event.war_ended": "Krieg gegen {name} [{tag}] beendet · Sieger {winner}",
  "alliance.diplomacy.event.peace": "Frieden mit {name} [{tag}]",
  "alliance.diplomacy.event.surrendered": "Kapitulation · {name} [{tag}]",
  "alliance.diplomacy.toast.proposed": "Bündnis vorgeschlagen.",
  "alliance.diplomacy.toast.peaceProposed": "Frieden vorgeschlagen.",
  "alliance.diplomacy.toast.accepted": "Vorschlag angenommen.",
  "alliance.diplomacy.toast.declined": "Vorschlag abgelehnt.",
  "alliance.diplomacy.toast.hostile": "Feindschaft erklärt.",
  "alliance.diplomacy.toast.neutral": "Beziehung geändert.",
  "alliance.diplomacy.toast.war": "Krieg erklärt · 12 h Vorlauf.",
  "alliance.diplomacy.toast.surrendered": "Kapituliert.",
  "alliance.log.diplomacy": "Diplomatie: {event} · {tag}",
  "world.outcome.allied": "Verbündet · kein Angriff",
  "alliance.contribute.title": "Beitragen",
  "alliance.contribute.hint": "Jedes Los bringt der Allianz Erfahrung und dem fokussierten Gebäude Fortschritt; du bekommst Allianzmünzen für den Shop.",
  "alliance.contribute.today": "Heute {n}/{max} Lose",
  "alliance.contribute.capped": "Tageslimit erreicht",
  "alliance.contribute.lotTitle": "+{xp} XP · +{coins} Münzen · +{progress} Fortschritt",
  "alliance.contribute.done": "Beigetragen: +{xp} XP, +{coins} Münzen.",
  "alliance.contribute.focus": "Fokus-Gebäude",
  "alliance.contribute.noFocus": "Noch kein Fokus-Gebäude gewählt; Beiträge bringen trotzdem XP und Münzen.",
  "alliance.contribute.noFocusOfficer": "Wähle unter Gebäude, wohin die Beiträge fließen.",
  "alliance.buildings.hint": "Allianzstufe {n}: Gebäude steigen bis zur halben Allianzstufe (aufgerundet), höchstens 5.",
  "alliance.buildings.level": "Stufe {n}/{max}",
  "alliance.buildings.total": "aktuell",
  "alliance.buildings.capped": "Höchststufe für diese Allianzstufe erreicht.",
  "alliance.buildings.focused": "Fokus",
  "alliance.buildings.setFocus": "Zum Fokus machen",
  "alliance.buildings.focusSet": "Fokus gesetzt.",
  "alliance.effect.memberCap": "+{n} Mitglieder je Stufe",
  "alliance.effect.atkPct": "+{n} % Angriff je Stufe",
  "alliance.effect.defPct": "+{n} % Verteidigung je Stufe",
  "alliance.effect.marchGatherPct": "+{n} % Marsch und Sammeln je Stufe",
  "alliance.effect.shopTier": "Shop-Stufe +{n} und −2 % Preise je Stufe",
  "alliance.effect.assistMax": "+{n} Bauhilfe je Stufe",
  "alliance.effectTotal.memberCap": "+{n} Mitglieder",
  "alliance.effectTotal.atkPct": "+{n} % Angriff",
  "alliance.effectTotal.defPct": "+{n} % Verteidigung",
  "alliance.effectTotal.marchGatherPct": "+{n} % Marsch und Sammeln",
  "alliance.effectTotal.shopTier": "Shop-Stufe {n}",
  "alliance.effectTotal.assistMax": "+{n} Bauhilfe",
  "alliance.shop.hint": "Bezahlt mit Allianzmünzen aus Beiträgen; höhere Regale schaltet der Handelsknoten frei.",
  "alliance.gifts.title": "Geschenke",
  "alliance.gifts.hint": "Kauft ein Mitglied ein Paket ab Bronze, bekommt die ganze Allianz ein Geschenk. Jedes Mitglied holt es einmal ab, 24 Stunden lang.",
  "alliance.gifts.none": "Gerade liegt kein Geschenk bereit.",
  "alliance.gifts.claim": "Abholen",
  "alliance.gifts.claimed": "Abgeholt",
  "alliance.gifts.claimedToast": "Geschenk abgeholt.",
  "alliance.gifts.tier.bronze": "Bronze",
  "alliance.gifts.tier.silver": "Silber",
  "alliance.gifts.tier.gold": "Gold",
  "alliance.gifts.tier.platinum": "Platin",
  "alliance.gifts.source.pack": "Paket von {name}",
  "alliance.gifts.source.duel": "Duellsieg",
  "alliance.gifts.source.milestone": "Meilenstein",
  "alliance.gifts.source.test": "{name}",
  "alliance.level": "Stufe {n}",
  "alliance.power": "Kraft",
  "alliance.members": "{n}/{max} Mitglieder",
  "alliance.leader": "Leitung:",
  "alliance.role.leader": "Anführer:in",
  "alliance.role.officer": "Offizier:in",
  "alliance.role.veteran": "Veteran:in",
  "alliance.role.member": "Mitglied",
  "alliance.policy.open": "Offen",
  "alliance.policy.approval": "Mit Bestätigung",
  "alliance.policy.closed": "Geschlossen",
  "alliance.find.title": "Allianz finden",
  "alliance.find.hint": "Allianzen helfen beim Bauen aus jeder Entfernung, haben einen eigenen Chat und später Gebäude, Shop und Diplomatie.",
  "alliance.find.placeholder": "Name oder Kürzel …",
  "alliance.find.none": "Keine Allianz gefunden. Gründe die erste.",
  "alliance.join": "Beitreten",
  "alliance.apply": "Bewerben",
  "alliance.applied": "Beworben",
  "alliance.closed": "Geschlossen",
  "alliance.full": "Voll",
  "alliance.accept": "Annehmen",
  "alliance.decline": "Ablehnen",
  "alliance.invitedBy": "eingeladen von {name}",
  "alliance.create.title": "Gründen",
  "alliance.create.hint": "Gründung ab HQ {hq} für {credits} ₵. Name 3–24 Zeichen, Kürzel 2–4 Großbuchstaben oder Ziffern.",
  "alliance.create.name": "Name",
  "alliance.create.tag": "Kürzel",
  "alliance.create.description": "Beschreibung (optional)",
  "alliance.create.submit": "Allianz gründen",
  "alliance.notice": "Ankündigung",
  "alliance.noNotice": "Noch keine Ankündigung.",
  "alliance.help.title": "Bauhilfe",
  "alliance.help.hint": "Mitglieder helfen sich beim Bauen aus jeder Entfernung; jede Hilfe kürzt den Timer.",
  "alliance.help.all": "Allen helfen",
  "alliance.help.building": "Ausbau auf Stufe {n}",
  "alliance.help.helpers": "Helfer",
  "alliance.help.open": "offen",
  "alliance.help.done": "erledigt",
  "alliance.help.none": "Gerade baut niemand.",
  "alliance.chat": "Allianz-Chat",
  "alliance.contribute": "Beitragen",
  "alliance.shop": "Allianz-Shop",
  "alliance.soon": "Kommt mit dem nächsten Paket.",
  "alliance.membership": "Mitgliedschaft",
  "alliance.leave": "Allianz verlassen",
  "alliance.leaveConfirm": "Wirklich verlassen? Danach eine Stunde Sperre für den nächsten Beitritt.",
  "alliance.disband": "Allianz auflösen",
  "alliance.visit": "Besuchen",
  "alliance.transfer": "Leitung übergeben",
  "alliance.requests.officersOnly": "Bewerbungen sehen Offiziere und die Leitung.",
  "alliance.requests.none": "Keine offenen Bewerbungen.",
  "alliance.log.none": "Noch keine Einträge.",
  "alliance.log.created": "{name} hat die Allianz gegründet.",
  "alliance.log.joined": "{name} ist beigetreten.",
  "alliance.log.left": "{name} hat die Allianz verlassen.",
  "alliance.log.kicked": "{name} hat ein Mitglied entfernt.",
  "alliance.log.role": "{name} hat eine Rolle geändert: {role}.",
  "alliance.log.transferred": "{name} hat die Leitung übergeben.",
  "alliance.log.invited": "{name} hat jemanden eingeladen.",
  "alliance.log.updated": "{name} hat Einstellungen geändert.",
  "alliance.log.disbanded": "{name} hat die Allianz aufgelöst.",
  "alliance.visit.title": "Zu Besuch bei {name}",
  "alliance.toast.created": "Allianz gegründet.",
  "alliance.toast.joined": "Willkommen in der Allianz.",
  "alliance.toast.applied": "Bewerbung gesendet.",
  "alliance.toast.left": "Allianz verlassen.",
  "alliance.toast.helped": "{n}× geholfen.",
  "alliance.toast.noticeSaved": "Ankündigung gespeichert.",
  "alliance.toast.role": "Rolle geändert.",
  "alliance.toast.kicked": "Mitglied entfernt.",
  "alliance.toast.transferred": "Leitung übergeben.",
  "alliance.toast.accepted": "Aufgenommen.",
  "alliance.toast.declined": "Abgelehnt.",
  "alliance.toast.disbanded": "Allianz aufgelöst.",
  "base.error.ALREADY_MEMBER": "Du bist schon in einer Allianz.",
  "base.error.COOLDOWN": "Nach dem Verlassen gilt eine Stunde Sperre.",
  "base.error.HQ_TOO_LOW": "Dein HQ ist dafür noch zu niedrig.",
  "base.error.NAME_TAKEN": "Name oder Kürzel ist schon vergeben.",
  "base.error.ALLIANCE_FULL": "Die Allianz ist voll.",
  "base.error.CLOSED": "Die Allianz nimmt keine Mitglieder auf.",
  "base.error.ALREADY_APPLIED": "Deine Bewerbung läuft noch.",
  "base.error.LEADER_MUST_TRANSFER": "Übergib erst die Leitung oder löse die Allianz auf.",
  "base.error.OFFICERS_FULL": "Es gibt schon fünf Offiziere.",
  "base.error.NOT_MEMBER": "Du bist in keiner Allianz.",
  "res.RAT": "Rationen",
  "res.POL": "Polymer",
  "res.ALY": "Legierung",
  "res.ENC": "Energiezellen",
  "res.SCR": "Scrip",
  "res.stamina": "Treibstoff",
  "fuel.title": "Treibstoff",
  "fuel.hint": "treibt Märsche, Expeditionen und Jagden an. Regeneriert von selbst.",
  "fuel.owned": "Dein Vorrat",
  "fuel.buy": "Nachfüllen",
  "fuel.use": "Einsetzen",
  "fuel.open": "Treibstoff nachfüllen",
  "settings.title": "Einstellungen",
  "settings.language": "Sprache",
  "settings.language.de": "Deutsch",
  "settings.language.en": "English",
  "settings.password": "Passwort ändern",
  "settings.password.current": "Aktuelles Passwort",
  "settings.password.next": "Neues Passwort",
  "settings.password.changed": "Passwort geändert.",
  "settings.invites": "Einladungen",
  "settings.invites.hint": "Dieser Server ist auf Einladung. Jedes Konto kann Codes erzeugen; ein Code lässt genau einen neuen Spieler herein und bringt dir selbst nichts ein.",
  "settings.invites.create": "Code erzeugen",
  "settings.invites.open": "{open} von {max} offen",
  "settings.invites.used": "eingelöst von {name}",
  "settings.invites.free": "noch frei",
  "settings.invites.copy": "Kopieren",
  "settings.invites.copied": "Code kopiert.",
  "settings.invites.copyFailed": "Kopieren hat nicht geklappt – markiere den Code von Hand.",
  "settings.invites.none": "Noch keine Codes erzeugt.",
  "settings.invites.limit": "Du hast schon {max} offene Codes. Warte, bis einer eingelöst wird.",
  "settings.invites.failed": "Der Code konnte nicht erzeugt werden. Versuch es noch einmal.",
  "settings.apiKeys": "API-Schlüssel",
  "settings.apiKeys.hint": "Für KI-Spieler und Bots. Der Schlüssel wird nur einmal angezeigt.",
  "settings.apiKeys.label": "Bezeichnung",
  "settings.apiKeys.create": "Schlüssel erstellen",
  "settings.apiKeys.revoke": "Widerrufen",
  "settings.apiKeys.new": "Dein neuer Schlüssel (jetzt kopieren):",
  "settings.apiKeys.none": "Noch keine Schlüssel.",
  "settings.apiKeys.scopes": "Rechte",
  "settings.sessions": "Sitzungen",
  "settings.sessions.current": "diese",
  "settings.graphics": "Grafikqualität",
  "settings.graphics.auto": "Automatisch",
  "settings.graphics.low": "Niedrig",
  "settings.graphics.medium": "Mittel",
  "settings.graphics.high": "Hoch",
  "settings.reducedMotion": "Weniger Animationen",
  "settings.saved": "Gespeichert.",
  "common.save": "Speichern",
  "common.cancel": "Abbrechen",
  "common.back": "Zurück",
  "common.loading": "Lädt …",
  "common.online": "online",
  "common.offline": "offline",
  "common.reconnecting": "Verbindung wird wiederhergestellt …",
  "placeholder.pending": "Dieser Bereich kommt in Teilprojekt {n}.",
  "scene.lost": "Die Grafik wurde vom Browser angehalten",
  "scene.lost.hint": "Das passiert auf Telefonen, wenn der Speicher knapp wird. Die Szene baut sich neu auf, sobald der Browser sie freigibt.",
  "scene.lost.retry": "Jetzt neu aufbauen",
  "scene.quality": "Qualität: {q}",
  "units.tab.roster": "Frames",
  "units.tab.squads": "Trupps",
  "units.tab.workshop": "Werkstatt",
  "units.tab.repair": "Reparatur",
  "units.tab.armory": "Waffenkammer",
  "units.tab.collection": "Sammlung",
  "units.all": "Alle",
  "units.count": "{n, plural, one {# Frame} other {# Frames}}",
  "units.inSquad": "Trupp {n}",
  "units.autoEquip": "Auto-Ausrüsten",
  "units.autoEquip.always": "Immer automatisch",
  "units.autoEquip.done": "{n} Module angelegt",
  "units.autoEquip.none": "Nichts anzulegen",
  "units.autoEquip.newUnits": "Neue Einheiten ausrüsten",
  "units.autoEquip.module": "Auf beste Einheit legen",
  "settings.automation": "Automatik",
  "settings.autoEquipUnits": "Neue Einheiten automatisch ausrüsten",
  "settings.autoEquipModules": "Neue Module automatisch anlegen",
  "units.squad.n": "Trupp {n}",
  "units.squads": "Trupps",
  "units.chemistry": "Chemie",
  "units.commanderHp": "Ø der Kämpfer",
  "units.stat.interval": "Angriffstakt",
  "units.stat.energy": "Energie/Angriff",
  "units.stat.cargo": "Fracht",
  "units.wrecked": "Zerstört",
  "units.repair": "Reparieren",
  "units.repairing": "In Reparatur",
  "units.level": "Stufe",
  "units.levelCapHint": "Limit erreicht: Sternrang {stars} und HQ {hq}. Sterne oder HQ erhöhen.",
  "units.star.count": "{n} von {max} Sternen",
  "armory.dismantle": "Modul zerlegen",
  "social.profile.locked": "Gesperrt",
  "units.xpToNext": "Noch {n} EXP bis zur nächsten Stufe",
  "units.xp.none": "Keine Trainingsdaten im Inventar.",
  "units.star.next": "Stern {n}",
  "units.star.up": "Stern aufwerten",
  "units.star.hint": "Duplikate bringen 10 Fragmente. Universalfragmente der Stufe füllen die Lücke.",
  "units.abilities": "Fähigkeiten",
  "units.abilityCap": "Hangar {n} begrenzt",
  "units.modules": "Module",
  "units.modules.none": "Kein passendes Modul im Depot.",
  "units.unequip": "Ablegen",
  "units.autofill": "Auto-Aufstellung",
  "units.setGarrison": "Als Garnison",
  "units.garrison": "Garnison",
  "units.slotClear": "Leeren",
  "units.noneEligible": "Kein Frame passt in diesen Platz.",
  "units.linkLegend": "Grün = gleicher Hersteller, Gold = Kommandant, Rot = Rivalen.",
  "units.roleHint.commander": "Kommandanten setzen das Zielprotokoll und pulsen Buffs.",
  "units.roleHint.defender": "Verteidiger halten die Linie und ziehen Feuer.",
  "units.roleHint.attacker": "Angreifer liefern Dauerschaden.",
  "units.roleHint.saboteur": "Saboteure treffen die Nachhut und schwächen.",
  "units.roleHint.support": "Supports geben passive Auren und Reparaturimpulse.",
  "units.toast.xp": "Trainingsdaten angewendet.",
  "units.toast.star": "Stern aufgewertet!",
  "units.viewer.error": "Das Einheitenmodell konnte nicht geladen werden.",
  "units.viewer.actions": "Einheit in Aktion ansehen",
  "units.viewer.idle": "Bereitschaft",
  "units.viewer.walk": "Bewegen",
  "units.viewer.attack": "Angreifen",
  "units.viewer.hit": "Treffer",
  "units.viewer.death": "Ausfall",
  "units.ceremony.title": "Sternaufwertung abgeschlossen",
  "units.ceremony.stars": "Sternrang {n} erreicht",
  "units.ceremony.model": "Aufgewertetes 3D-Modell: {name}",
  "units.ceremony.modelError": "Die Aufwertung ist gespeichert. Das 3D-Modell konnte gerade nicht geladen werden.",
  "units.ceremony.power": "Stärke",
  "units.ceremony.levelCap": "Stufenlimit",
  "units.ceremony.saved": "Dein neuer Sternrang ist gespeichert und sofort aktiv.",
  "units.ceremony.awakened": "Erwacht! Dein maximaler Sternrang ist gespeichert und aktiv.",
  "units.ceremony.skip": "Animation überspringen",
  "units.ceremony.continue": "Zur Einheit",
  "units.toast.ability": "Fähigkeit verbessert.",
  "units.toast.equip": "Modul angelegt.",
  "units.toast.unequip": "Modul abgelegt.",
  "units.toast.squad": "Aufstellung gespeichert.",
  "units.toast.autofill": "Aufstellung nach Macht gefüllt.",
  "units.toast.garrison": "Garnison gesetzt.",
  "units.toast.repair": "Reparatur gestartet.",
  "units.toast.repairAll": "Alle Reparaturen gestartet.",
  "units.toast.craft": "Fertigung gestartet.",
  "units.toast.enhance": "Modul verbessert.",
  "units.toast.dismantle": "Modul zerlegt.",
  "units.toast.milestone": "Belohnung abgeholt.",
  "role.commander": "Kommandant",
  "role.defender": "Verteidiger",
  "role.attacker": "Angreifer",
  "role.saboteur": "Saboteur",
  "role.support": "Support",
  "chassis.tank": "Panzer",
  "chassis.mecha": "Mecha",
  "chassis.tripod": "Tripod",
  "chassis.android": "Android",
  "chassis.drone_carrier": "Drohnenträger",
  "slot.commander": "Kommandant",
  "slot.f1": "Kämpfer 1",
  "slot.f2": "Kämpfer 2",
  "slot.f3": "Kämpfer 3",
  "slot.f4": "Kämpfer 4",
  "slot.s1": "Support 1",
  "slot.s2": "Support 2",
  "doctrine.column": "Kolonne",
  "doctrine.column.hint": "Drei Kämpfer mit gleichem Chassis: +5 % Leben.",
  "doctrine.balanced": "Ausgewogen",
  "doctrine.balanced.hint": "Verteidiger, Angreifer und Saboteur im Trupp: +3 % Angriff.",
  "doctrine.uplink": "Uplink",
  "doctrine.uplink.hint": "Zwei Supports desselben Herstellers: +10 % Aurastärke.",
  "module.slot.weapon": "Waffe",
  "module.slot.armor": "Panzerung",
  "module.slot.core": "Kern",
  "module.slot.sensor": "Sensor",
  "stat.hp": "HP",
  "stat.atk": "ATK",
  "stat.def": "DEF",
  "stat.crit": "CRIT",
  "stat.critDmg": "CRIT-Schaden",
  "stat.acc": "ACC",
  "stat.eva": "EVA",
  "stat.energyPerAttack": "Energie",
  "stat.intervalTicks": "Tempo",
  "workshop.featured": "Featured",
  "offer.choose": "Fabrikationsangebot wählen",
  "offer.kind.standard": "Standard",
  "offer.kind.featured": "Spotlight",
  "offer.kind.manufacturer": "Hersteller",
  "offer.freeBadge": "GRATIS",
  "offer.subtitle.standard": "Frames aus allen fünf Herstellern",
  "offer.subtitle.featured": "Ein wechselnder S-Frame im Spotlight",
  "offer.manufacturerOnly": "Nur Frames von {mfr}",
  "offer.changes": "Wechselt in",
  "offer.opening": "Erster Standard-Frame · garantiert",
  "offer.spotlight": "Aktueller Spotlight-Frame",
  "offer.examples": "Mögliche Frames · Beispiel",
  "offer.sGuarantee": "S in spätestens {n} Ziehungen",
  "offer.aGuarantee": "A oder S in spätestens {n}",
  "offer.openingShort": "Erste Standard-Ziehung: Schildwall Mk2 (B) garantiert.",
  "offer.featuredGuaranteed": "Dein nächster S-Frame ist garantiert {name}.",
  "offer.featuredChance": "Beim nächsten S-Frame: 50% Chance auf {name}.",
  "offer.count": "Anzahl der Frames",
  "offer.frames": "{n}× Frame",
  "offer.owned": "Bestand: {n}",
  "offer.vipFree": "Gratis-Ziehung ab VIP {n} · VIP öffnen",
  "offer.freeSingle": "1 Frame gratis fabrizieren",
  "offer.details": "Chancen & alle {n} möglichen Frames",
  "offer.baseRates": "Basisraten vor Garantien und erhöhten S-Chancen:",
  "offer.pityExplanation": "Nach {n} Ziehungen ohne S steigt die S-Chance. A-/S-Garantien erhöhen den Rang; nicht im Angebot enthaltene Ränge werden auf den nächsten verfügbaren höheren Rang angehoben.",
  "workshop.thisWeek": "Diese Woche",
  "workshop.manufacturerPromotion": "Herstellerwoche: +{pct}% auf die Werte von {mfr}-Einheiten",
  "events.manufacturerInactive": "Dieser Lauf gewährt derzeit keinen Herstellerbonus.",
  "base.error.BANNER_CHANGED": "Das Banner hat gewechselt. Prüfe die jetzt hervorgehobene Einheit; es wurde nichts verbraucht.",
  "workshop.pity": "Pity {n}/{max}",
  "workshop.pityA": "A-Garantie in {n}",
  "workshop.guaranteed": "Featured garantiert",
  "workshop.softPity": "Soft Pity ab {n}",
  "workshop.free": "Gratis-Zug",
  "workshop.freeUsed.day": "Gratis-Zug morgen wieder",
  "workshop.freeUsed.week": "Gratis-Zug nächste Woche",
  "workshop.token": "FAB",
  "workshop.hint": "Jede Minute ein Credit. Ein Zehnerzug kostet 1 350 ₵, ein Tag bringt 1 440.",
  "workshop.openingDefender": "Deine erste Standard-Fabrikation garantiert Schildwall Mk2 (B, Verteidiger). Danach gelten die angezeigten Raten.",
  "workshop.skip": "Überspringen",
  "workshop.tapNext": "Tippen für den nächsten Frame",
  "workshop.tapSkip": "Tippen zum Beschleunigen",
  "workshop.result": "{n} Frames fabriziert",
  "repair.full": "Alle Reparaturplätze belegt",
  "repair.damaged": "Beschädigt",
  "repair.accelerate": "Beschleunigen",
  "repair.finish": "Sofort abschließen",
  "units.compare.allStats": "Alle Werte anzeigen",
  "units.compare.setDetails": "Herstellersets vergleichen",
  "repair.slots": "Plätze",
  "repair.speed": "Tempo +{pct}%",
  "repair.bay": "Reparaturdock Stufe {n}",
  "repair.noBay": "Ohne Reparaturdock: ein Notfallplatz.",
  "repair.all": "Alle reparieren",
  "repair.none": "Alle Frames sind einsatzbereit.",
  "armory.queue": "Fertigung",
  "armory.maxTier": "bis Stufe {tier}",
  "armory.level": "Waffenkammer Stufe {n}",
  "armory.locked": "Waffenkammer ab HQ 10.",
  "armory.modules": "Module",
  "armory.blueprints": "Blaupausen",
  "armory.crafting": "wird gefertigt",
  "armory.noBlueprints": "Keine Blaupausen. Expeditionen ab Stufe 3 liefern welche.",
  "armory.noModules": "Noch keine Module.",
  "armory.craft": "Fertigen",
  "armory.blueprintHint": "{n} Blaupausen: 5 Hersteller × 5 Plätze × Ränge B/A/S.",
  "craft.destination": "Fertige Module landen automatisch im Depot.",
  "craft.toBase": "Zur Basis",
  "craft.idle": "Fertigungsplatz frei · Wähle eine Blaupause.",
  "craft.accelerate": "Beschleunigen",
  "craft.finish": "Jetzt fertigstellen",
  "craft.title": "Deine Blaupausen",
  "craft.recipeHint": "Ein Bauplan ergibt ein fertiges Modul. Kosten: Bestand / Bedarf.",
  "craft.findPlans": "Blaupausen finden",
  "craft.recipes": "{n} Rezepte",
  "craft.tierLocked": "Fertigung für Rang {tier} noch gesperrt.",
  "craft.queueFull": "Alle Fertigungsplätze belegt.",
  "craft.missing": "Material fehlt · siehe markierte Kosten.",
  "craft.ready": "Bereit zur Fertigung",
  "craft.speed": "+{n}% Tempo",
  "craft.cost": "Bestand und Fertigungskosten",
  "craft.done": "Fertig · im Depot",
  "craft.equip": "Vergleichen & ausrüsten",
  "battle.attacker": "Angreifer",
  "battle.defender": "Verteidiger",
  "battle.taken": "Erlitten",
  "battle.heal": "Heilung",
  "battle.victory": "Sieg",
  "battle.growth": "Einheitenfortschritt",
  "battle.wave": "Welle",
  "battle.wear": "HP von {before}% auf {after}%",
  "battle.xpStored": "Levelgrenze erreicht · {n} XP gespeichert",
  "battle.repair.heading": "Aktuelle Reparaturwarteschlange",
  "battle.repair.unavailable": "Die Reparaturverfügbarkeit konnte nicht geladen werden. Aktualisieren liefert eine aktuelle Vorschau.",
  "battle.repair.free": "Ersatzteile (ALY) und Kühlmittel (POL) werden beim Start verbraucht. {used} von {slots} Werkstattplätzen belegt.",
  "battle.repair.counts": "{ready} können jetzt starten · {queued} bereits in Reparatur · {deployed} unterwegs",
  "battle.repair.duration": "Diese Reparaturen dauern bei aktuellem Tempo höchstens {time}.",
  "battle.repair.units": "Beschädigte Einheiten ({n})",
  "battle.repair.ready": "Bereit zur Reparatur",
  "battle.repair.queued": "In Reparatur",
  "battle.repair.deployed": "Unterwegs · nicht verfügbar",
  "battle.repair.queue": "{n} Reparaturen starten",
  "battle.repair.refresh": "Vorschau aktualisieren",
  "battle.repair.started": "{n} Reparaturen gestartet. Die Warteschlange wurde aktualisiert.",
  "battle.again": "Erneut angreifen",
  "battle.again.target": "Ziel {target} · Trupp {squad}. Es gelten aktuelle Kosten und Verfügbarkeit.",
  "battle.modelsUnavailable": "Einige Kampfmodelle konnten nicht geladen werden. Positionsmarkierungen und Bericht bleiben verfügbar.",
  "battle.pause": "Wiedergabe pausieren",
  "battle.resume": "Wiedergabe fortsetzen",
  "battle.reduced": "Reduzierte Bewegung",
  "battle.defeat": "Niederlage",
  "battle.duration": "{s} s",
  "battle.timeout": "Zeitlimit",
  "battle.replay": "Wiederholung",
  "battle.skip": "Zum Ergebnis",
  "battle.ultimate": "ULTIMATE",
  "battle.turret": "Geschütz",
  "arena.title": "Arena",
  "arena.attempts": "Versuche",
  "arena.attempt": "Versuch",
  "arena.refresh": "Gegner neu",
  "arena.defence": "Verteidigung: Trupp {n}",
  "arena.opponents": "Gegner",
  "arena.noOpponents": "Gerade keine Gegner in Reichweite. Bots und Spieler füllen die Leiter.",
  "arena.attack": "Angreifen",
  "arena.season": "Saison",
  "arena.endsIn": "endet in",
  "arena.top": "Top 10",
  "arena.log": "Gefechtslog",
  "arena.noLog": "Noch keine Arenakämpfe.",
  "arena.revenge": "Rache",
  "arena.toast.refreshed": "Neue Gegner.",
  "arena.toast.refilled": "Versuch aufgefüllt.",
  "expedition.title": "Expeditionen",
  "expedition.sweeps": "Gratis-Sweeps",
  "expedition.stamina": "{n} Treibstoff",
  "expedition.attack": "Angreifen",
  "expedition.sweep": "Sweep",
  "expedition.firstClear": "Erstabschluss",
  "expedition.toast.sweep": "Sweep abgeschlossen.",
  "expedition.toast.chest": "Truhe geöffnet.",
  "purpose.workshop": "Fabrikation",
  "purpose.openWorkshop": "Werkstatt öffnen",
  "purpose.hangar": "Hangar",
  "purpose.openRoster": "Frames verwalten",
  "purpose.repair": "Reparaturdock",
  "purpose.openRepair": "Reparaturen öffnen",
  "purpose.armory": "Waffenkammer",
  "purpose.openArmory": "Waffenkammer öffnen",
  "purpose.command": "Kommandozentrale",
  "purpose.openSquads": "Formation öffnen",
  "purpose.arena": "Arena-Terminal",
  "purpose.openArena": "Arena öffnen",
  "purpose.expedition": "Expeditionsbüro",
  "purpose.openExpeditions": "Expeditionen öffnen",
  "purpose.trainer": "Trainingssimulator",
  "trainer.pooled": "{n} EXP gesammelt",
  "trainer.cap": "sammelt bis zu {h} h",
  "trainer.claim": "{n}× Trainingsdaten abholen",
  "trainer.toast": "Trainingsdaten abgeholt.",
  "common.close": "Schließen",
  "cat.core": "Kern",
  "cat.production": "Produktion",
  "cat.units": "Einheiten",
  "cat.research": "Forschung",
  "cat.economy": "Wirtschaft",
  "cat.defense": "Verteidigung",
  "cat.social": "Sozial",
  "zone.north": "Nordsektor",
  "zone.east": "Ostsektor",
  "zone.south": "Südsektor",
  "zone.west": "Westsektor",
  "base.build.title": "Bauen",
  "base.build.action": "Bauen",
  "base.build.locked": "Ab HQ {n}",
  "base.build.copies": "{built}/{max} gebaut",
  "base.build.nextCopy": "nächste Kopie ab HQ {n}",
  "base.build.ready": "Bereit zum Bauen",
  "base.build.lockedGroup": "Später verfügbar",
  "base.build.builtGroup": "Gebaut",
  "base.build.new": "NEU",
  "base.build.needed": "Für HQ {n} nötig",
  "base.build.noRoom": "Kein Platz frei",
  "base.build.upgrade": "Ausbauen",
  "base.build.filterAll": "Alle",
  "base.build.empty": "In dieser Kategorie gibt es nichts zu bauen.",
  "base.build.readyCount": "{n} baubar",
  "base.place.valid": "Freien Platz antippen oder Gebäude ziehen. Dann bestätigen.",
  "base.place.invalid": "Hier ist kein Platz.",
  "base.place.confirm": "Bestätigen",
  "base.state.constructing": "Im Bau",
  "base.state.upgrading": "Ausbau auf Stufe {n}",
  "base.speedup.title": "Beschleunigen",
  "base.speedup.none": "Keine passenden Beschleunigungen im Inventar.",
  "base.instant": "Sofort fertig · {n} ₵",
  "base.cancel": "Abbrechen (volle Rückerstattung)",
  "base.attributes": "Werte",
  "base.upgrade": "Ausbauen",
  "base.upgrade.to": "Ausbau auf Stufe {n}",
  "base.move": "Verschieben",
  "base.rotateInPlace": "Drehen",
  "base.show": "Anzeigen",
  "base.all": "Alle Gebäude",
  "base.shortcut.pending": "Dieses Gebäude öffnet seinen Bereich mit dem Store-Teilprojekt.",
  "base.gate.title": "Querschnitt",
  "base.gate.summary": "Durchschnitt {avg} · benötigt {req}",
  "base.gate.ok": "HQ-Ausbau frei",
  "base.gate.blocked": "{n} Gebäude bremsen",
  "base.gate.maxed": "Maximum",
  "base.gate.hint": "Das HQ steigt nur, wenn der Durchschnitt aller freigeschalteten Gebäude die Anforderung erreicht. Ungebaute Typen zählen als Stufe 0.",
  "base.gate.drags": "Bremser",
  "base.hq.title": "Kommandonexus · Stufe {n}",
  "base.hq.open": "Querschnitt & Übersicht",
  "base.hq.upgrade": "HQ auf Stufe {n}",
  "base.power.title": "Energie",
  "base.power.ok": "Versorgt",
  "base.power.deficit": "Defizit · Produktion {pct}%",
  "base.power.score": "Macht {n}",
  "base.capacity": "Lager {n}",
  "base.queue.title": "Bauschlange & Bauleiter",
  "base.queue.build": "Bauschlange",
  "base.queue.research": "Forschungsschlange",
  "base.queue.permanent": "{n} dauerhaft",
  "base.queue.rental": "Gemieteter Platz {n}",
  "base.queue.chooseSlot": "Bauplatz auswählen",
  "base.queue.builderNumber": "Bauleiter {n}",
  "base.queue.slotNumber": "Platz {n}",
  "base.queue.period.day": "1 Tag",
  "base.queue.period.week": "1 Woche",
  "base.queue.period.month": "30 Tage",
  "base.zones.title": "Sektoren",
  "base.zones.hint": "Sektoren erweitern die Baufläche deiner Enklave. Besiege die Garnison mit deinem Trupp. Danach kostet die Sicherung Ressourcen und Zeit. Die benötigte HQ-Stufe steht beim jeweiligen Sektor.",
  "base.zones.state.locked": "Verseucht",
  "base.zones.state.reclaiming": "Rückeroberung",
  "base.zones.state.open": "Gesichert",
  "base.zones.reclaim": "Zurückerobern",
  "base.zones.reclaiming": "Wird gesichert …",
  "base.protocols.title": "Nexus-Protokolle",
  "base.protocols.hint": "Zeitlich begrenzte Boni für die ganze Enklave. Credits oder Scrip.",
  "base.layouts.title": "Layouts",
  "base.layouts.hint": "Speichere die Anordnung und stelle sie mit einem Tipp wieder her.",
  "base.layouts.slot": "Layout {n}",
  "base.layouts.empty": "leer",
  "base.layouts.apply": "Anwenden",
  "base.reason.gate": "Querschnitt {avg} unter {req}",
  "base.reason.hqcap": "HQ Stufe {n} begrenzt dieses Gebäude",
  "base.reason.busy": "Gerade beschäftigt",
  "base.reason.max": "Maximale Stufe erreicht",
  "base.reason.resources": "Nicht genug Ressourcen",
  "settings.autoCoverCosts": "Fehlende Kosten automatisch aus Kisten decken",
  "cover.missing": "Fehlt:",
  "cover.fromDepot": "Aus dem Inventar:",
  "cover.enough": "reicht",
  "cover.notEnough": "Reicht auch mit Inventar nicht, es fehlen",
  "cover.storage": "Lager zu klein für die Kiste",
  "cover.coverAndStart": "Aus Inventar decken & starten",
  "cover.autoTag": "deckt aus Kisten",
  "cover.vipHint": "Ab VIP {n} deckt der Start-Knopf fehlende Kosten automatisch aus Kisten.",
  "base.reason.static": "Nicht ausbaubar",
  "base.reason.queue": "Warteschlange voll",
  "base.toast.placed": "Bau gestartet.",
  "base.toast.moved": "Verschoben.",
  "base.toast.upgradeStarted": "Ausbau gestartet.",
  "base.toast.speedup": "Beschleunigt.",
  "base.toast.instant": "Fertig!",
  "base.toast.cancelled": "Abgebrochen, Ressourcen erstattet.",
  "base.toast.rented": "Warteschlange gemietet.",
  "base.toast.reclaiming": "Rückeroberung gestartet.",
  "base.toast.protocol": "Protokoll aktiv.",
  "base.toast.layoutSaved": "Layout gespeichert.",
  "base.toast.layoutApplied": "Layout angewendet.",
  "base.error.COPIES": "Alle Kopien dieses Gebäudes sind gebaut.",
  "base.error.LOCKED": "Noch nicht freigeschaltet.",
  "base.error.CELL_OCCUPIED": "Der Platz ist belegt.",
  "base.decorate.title": "Dekorieren",
  "base.decorate.hint": "Dekorationen kommen aus Truhen, Events und Shops. Platzieren belegt Felder wie ein Gebäude; Einlagern gibt das Stück zurück.",
  "base.decorate.placed": "{n}/{max} platziert",
  "base.decorate.owned": "Im Lager",
  "base.decorate.placedList": "Platziert",
  "base.decorate.nothingPlaced": "Noch nichts platziert.",
  "base.decorate.place": "Platzieren",
  "base.decorate.remove": "Einlagern",
  "base.decorate.move": "Verschieben",
  "base.decorate.none": "Noch keine Dekoration. Truhen, Events und Shops geben welche.",
  "base.decorate.morale": "+{n} Moral",
  "base.decorate.placedToast": "Platziert.",
  "base.decorate.storedToast": "Eingelagert.",
  "base.error.DECORATION_LIMIT": "Die Basis hat keinen Platz für mehr Dekoration; ein höheres HQ erlaubt mehr.",
  "inventory.decorationHint": "Auf der Basis platzieren; das Stück belegt Felder wie ein Gebäude.",
  "base.error.CELL_LOCKED": "Dieser Sektor ist noch verseucht.",
  "base.error.QUEUE_FULL": "Die Bauschlange ist voll.",
  "base.error.QUEUE_MAX": "Mehr Warteschlangen gibt es nicht.",
  "base.error.CANNOT_UPGRADE": "Ausbau derzeit nicht möglich.",
  "base.error.CANNOT_RESEARCH": "Forschung derzeit nicht möglich.",
  "base.error.NOT_RUNNING": "Hier läuft gerade nichts.",
  "base.error.ZONE_STATE": "Dieser Sektor kann gerade nicht zurückerobert werden.",
  "base.error.LAYOUT_INVALID": "Das Layout passt nicht mehr zur Enklave.",
  "base.error.INSUFFICIENT_RESOURCES": "Nicht genug Ressourcen.",
  "base.error.INSUFFICIENT_CREDITS": "Nicht genug Credits. Jede Minute bringt einen.",
  "base.error.INSUFFICIENT_ITEMS": "Nicht genug Gegenstände.",
  "base.error.INSUFFICIENT_SCRIP": "Nicht genug Scrip.",
  "research.title": "Forschung",
  "research.start": "Forschen · Stufe {n}",
  "research.requires": "Voraussetzung",
  "research.reason.lab": "Datenlabor erforderlich",
  "research.reason.tier": "Datenlabor-Stufe {have} unter {need}",
  "research.reason.requires": "Benötigt {name}",
  "research.board.lab": "Datenlabor · Stufe {n}",
  "research.board.labOpen": "Zum Labor",
  "research.board.labBuild": "Labor im Baukatalog",
  "research.board.target": "Forscht auf Stufe {n}",
  "research.board.stages": "Forschungsstufen · erlernte Technologien je Stufe",
  "research.board.ready": "Forschbar",
  "research.board.locked": "Voraussetzungen ansehen",
  "research.board.levelOne": "jeweils Stufe 1",
  "research.board.refund": "Abbrechen erstattet die eingesetzten Rohstoffe. Verwendete Beschleuniger werden nicht erstattet.",
  "research.reason.busy": "Wird gerade erforscht",
  "research.toast.started": "Forschung gestartet.",
  "attr.unitLevelCap": "Einheiten-Stufenlimit",
  "attr.squadSlotsBase": "Trupp-Plätze",
  "attr.wallHp": "Wall-HP",
  "attr.trapCapacity": "Fallenkapazität",
  "attr.vision": "Sichtweite",
  "attr.warningSec": "Vorwarnzeit",
  "attr.scoutDetail": "Spähdetail",
  "attr.production.RAT": "Rationen / h",
  "attr.production.POL": "Polymer / h",
  "attr.production.ALY": "Legierung / h",
  "attr.production.ENC": "Energiezellen / h",
  "attr.production.SCR": "Scrip / h",
  "attr.powerOutput": "Stromerzeugung",
  "attr.survivors": "Überlebende",
  "attr.capacity": "Lagerkapazität",
  "attr.protectedPct": "Geschützt",
  "attr.exchangeRatePct": "Tauschrate",
  "attr.salvageYieldPct": "Bergungsertrag",
  "attr.fabricationDiscountPct": "Fabrikationsrabatt",
  "attr.freePullsDaily": "Gratis-Züge / Tag",
  "attr.abilityLevelCap": "Fähigkeits-Limit",
  "attr.xpDiscountPct": "EXP-Rabatt",
  "attr.slots": "Plätze",
  "attr.repairSpeedPct": "Reparaturtempo",
  "attr.xpPerHour": "EXP / h",
  "attr.drillXp": "Drill-EXP",
  "attr.squads": "Trupps",
  "attr.presets": "Vorlagen",
  "attr.marchSpeedPct": "Marschtempo",
  "attr.maxModuleTier": "Max. Modulstufe",
  "attr.craftSpeedPct": "Fertigungstempo",
  "attr.researchSpeedPct": "Forschungstempo",
  "attr.maxResearchTier": "Max. Forschungsstufe",
  "attr.droneLevelCap": "Drohnen-Limit",
  "attr.droneBonusPct": "Drohnenbonus",
  "attr.stockSlots": "Handelsplätze",
  "attr.caravanCapacity": "Karawanenkapazität",
  "attr.exchangeFeePct": "Handelsgebühr",
  "attr.missionCap": "Missionslimit",
  "attr.missionsPerBatch": "Missionen je Welle",
  "attr.staminaCap": "Treibstofflimit",
  "attr.sweepTickets": "Sweep-Tickets",
  "attr.attempts": "Versuche",
  "attr.coinBonusPct": "Münzbonus",
  "attr.efficiencyPct": "Effizienz",
  "attr.gatherSpeedPct": "Sammeltempo",
  "attr.cargoPct": "Fracht",
  "attr.turretHp": "Geschütz-HP",
  "attr.turretAtk": "Geschütz-ATK",
  "attr.shieldDiscountPct": "Schildrabatt",
  "attr.antiScout": "Spähabwehr",
  "attr.trapDamage": "Fallenschaden",
  "attr.trapCapacityBonus": "Fallenkapazität +",
  "attr.messageLength": "Nachrichtenlänge",
  "attr.mailCapacity": "Postfach",
  "attr.titleSlots": "Titelplätze",
  "attr.killBonusPct": "Kill-Bonus",
  "rsh.effect.production.RAT": "Rationenproduktion",
  "rsh.effect.production.POL": "Polymerproduktion",
  "rsh.effect.production.ALY": "Legierungsproduktion",
  "rsh.effect.production.ENC": "Energiezellenproduktion",
  "rsh.effect.production.SCR": "Scrip-Produktion",
  "rsh.effect.production.all": "Gesamtproduktion",
  "rsh.effect.storage.capacity": "Lagerkapazität",
  "rsh.effect.storage.protected": "Geschützte Ressourcen",
  "rsh.effect.gather.speed": "Sammeltempo",
  "rsh.effect.march.cargo": "Marschfracht",
  "rsh.effect.march.speed": "Marschtempo",
  "rsh.effect.trade.discount": "Handelsrabatt",
  "rsh.effect.salvage.yield": "Bergungsertrag",
  "rsh.effect.unit.defender.hp": "Verteidiger-HP",
  "rsh.effect.unit.defender.def": "Verteidiger-DEF",
  "rsh.effect.unit.attacker.atk": "Angreifer-ATK",
  "rsh.effect.unit.saboteur.atk": "Saboteur-ATK",
  "rsh.effect.unit.saboteur.crit": "Saboteur-Krit",
  "rsh.effect.unit.commander.hp": "Kommandanten-HP",
  "rsh.effect.unit.support.aura": "Support-Aura",
  "rsh.effect.unit.chassis.tank": "Panzer-Chassis",
  "rsh.effect.unit.chassis.mecha": "Mecha-Chassis",
  "rsh.effect.unit.chassis.tripod": "Tripod-Chassis",
  "rsh.effect.unit.all.atk": "ATK aller Einheiten",
  "rsh.effect.unit.all.def": "DEF aller Einheiten",
  "rsh.effect.unit.all.hp": "HP aller Einheiten",
  "rsh.effect.unit.crit": "Kritische Treffer",
  "rsh.effect.unit.energy": "Energieaufbau",
  "rsh.effect.commander.pulse": "Kommandopuls",
  "rsh.effect.build.speed": "Bautempo",
  "rsh.effect.research.speed": "Forschungstempo",
  "rsh.effect.repair.speed": "Reparaturtempo",
  "rsh.effect.fabrication.discount": "Fabrikationsrabatt",
  "rsh.effect.march.slots": "Marschplätze",
  "rsh.effect.stamina.cap": "Treibstofflimit",
  "rsh.effect.xp.gain": "EXP-Gewinn",
  "rsh.effect.cdc.drop": "Datenkern-Drops",
  "rsh.effect.wall.hp": "Wall-HP",
  "rsh.effect.turret.power": "Geschützstärke",
  "rsh.effect.trap.capacity": "Fallenkapazität",
  "rsh.effect.trap.damage": "Fallenschaden",
  "rsh.effect.shield.discount": "Schildrabatt",
  "rsh.effect.burn.duration": "Branddauer",
  "rsh.effect.garrison.def": "Garnisons-DEF",
  "rsh.effect.garrison.atk": "Garnisons-ATK",
  "rsh.effect.scout.resist": "Spähabwehr",
  "rsh.effect.warning.time": "Vorwarnzeit",
  "world.kind.enclave": "Enklave",
  "world.kind.node": "Ressourcenfeld",
  "world.kind.pack": "Zombierudel",
  "world.kind.elite": "Elite-Rudel",
  "world.kind.hive": "Hive",
  "world.kind.boss": "Weltboss",
  "world.kind.ruin": "Ruine",
  "world.kind.camp": "Überlebendenlager",
  "world.kind.vault": "Tresor",
  "world.kind.citadel": "Zitadelle",
  "world.kind.empty": "Leeres Feld",
  "world.emptyTile": "Hier ist nichts. Ödland, so weit das Auge reicht.",
  "world.fogged": "im Nebel",
  "world.distance": "{n} Felder",
  "world.eta": "Marsch {time}",
  "world.remaining": "{n} übrig",
  "world.occupied": "Belegt",
  "world.gather": "Sammeln",
  "world.attack": "Angreifen",
  "world.raid": "Überfallen",
  "world.scout": "Spähen",
  "world.centre": "Zentrieren",
  "world.bookmark": "Merken",
  "world.share": "Koordinaten kopieren",
  "world.squad": "Trupp {n}",
  "world.npc": "NPC",
  "world.shielded": "Geschützt",
  "world.burning": "Brennt",
  "world.noShield": "Kein Schild",
  "world.desc.pack": "Ein Rudel Untoter. Sieg bringt Scrip, Bergungsmarken und mit etwas Glück Datenkerne.",
  "world.desc.elite": "Ein Elite-Rudel: härter, aber mit Datenkernen belohnt.",
  "world.desc.vault": "Ein versiegelter Tresor der Nekropole. Schwer bewacht, reich gefüllt.",
  "world.desc.hive": "Die Matriarchin hat noch {hp} % Lebenspunkte. Schaden bleibt bis zum Tagesreset erhalten.",
  "world.desc.boss": "Der Weltboss hat {hp} % Lebenspunkte. Das Fenster schließt in",
  "world.desc.ruin": "Einmalige Erkundung: Tür aufbrechen oder Schloss hacken?",
  "world.desc.camp": "Überlebende tauschen Ressourcen gegen Scrip und vergeben täglich drei Aufträge.",
  "world.desc.citadel": "Die Zitadelle im Ground Zero ist versiegelt. Noch.",
  "world.ruin.force": "Aufbrechen",
  "world.ruin.hack": "Hacken",
  "world.camp.tradesLeft": "{n} Tauschgeschäfte heute übrig",
  "world.camp.trade": "Tauschen",
  "world.camp.claim": "Abholen",
  "world.shield.buy": "Schild kaufen (Credits)",
  "world.shield.blocked": "Solange dein Angriff läuft, kann kein Schild aufgebaut werden.",
  "world.teleport.random": "Zufalls-Teleport",
  "world.teleport.newbieHint": "Während des Anfängerschilds ist ein gezielter Teleport kostenlos (Feld antippen, dann Teleport wählen).",
  "world.extinguish": "Löschen",
  "world.marches": "Märsche",
  "world.noMarches": "Keine Märsche unterwegs.",
  "world.recall": "Zurückrufen",
  "world.report": "Bericht",
  "world.find": "Suchen",
  "world.level": "Stufe",
  "world.searchPlayer": "Spielername",
  "world.bookmarks": "Lesezeichen",
  "world.noBookmarks": "Noch keine Lesezeichen.",
  "world.scouts": "Spähberichte",
  "world.noScouts": "Noch keine Spähberichte.",
  "world.detail": "Detail {n}",
  "world.squadSize": "{n} Einheiten",
  "world.garrisonKnown": "Garnison bekannt",
  "world.scoutBlocked": "Vom Störsender abgewehrt.",
  "world.boss": "Weltboss",
  "world.boss.titan": "Titan Necrolith",
  "world.boss.health": "Boss-Lebenspunkte",
  "world.boss.loadFailed": "Modell nicht geladen.",
  "world.zoom": "Kartenzoom",
  "world.zoom.near": "Nah",
  "world.zoom.tactical": "Taktik",
  "world.zoom.overview": "Übersicht",
  "world.boss.myDamage": "Dein Schaden: {n}",
  "world.boss.next": "Nächster Boss in",
  "world.boss.none": "Kein Boss angekündigt.",
  "world.attacks": "Angriffe",
  "world.noAttacks": "Keine Angriffe bisher.",
  "world.revenge": "Rache bis",
  "world.filters": "Filter",
  "world.incoming": "{n} Angriff(e)",
  "world.action.gather": "Sammeln",
  "world.action.attack": "Angriff",
  "world.action.scout": "Spähen",
  "world.action.explore": "Erkunden",
  "world.state.marching": "Unterwegs",
  "world.state.gathering": "Sammelt",
  "world.state.returning": "Rückweg",
  "world.state.done": "Zurück",
  "world.outcome.gathered": "{n} {res} geladen",
  "world.outcome.won": "Sieg",
  "world.outcome.lost": "Niederlage",
  "world.outcome.shielded": "Ziel war geschützt",
  "world.outcome.scouted": "Bericht erhalten",
  "world.outcome.explored": "Erkundet",
  "world.outcome.recalled": "Zurückgerufen",
  "world.outcome.noSquad": "Trupp nicht kampfbereit",
  "world.outcome.gathering": "Sammelt",
  "world.toast.marchStarted": "Marsch gestartet.",
  "world.toast.scoutSent": "Spähdrohne unterwegs.",
  "world.toast.recalled": "Trupp zurückgerufen.",
  "world.toast.copied": "Koordinaten kopiert.",
  "world.toast.bookmarked": "Lesezeichen gesetzt.",
  "world.toast.traded": "Getauscht.",
  "world.toast.claimed": "Belohnung abgeholt.",
  "world.toast.shielded": "Schild aktiv.",
  "world.toast.teleported": "Enklave verlegt.",
  "world.toast.extinguished": "Feuer gelöscht.",
  "world.toast.incoming": "Alarm: {name} greift an!",
  "world.wall": "Basiswall",
  "base.surfaceLoading": "Basisoberfläche wird geladen …",
  "base.surfaceUnavailable": "Die Basisoberfläche konnte nicht geladen werden.",
  "world.toast.defended": "Angriff von {name} abgewehrt.",
  "world.toast.raided": "{name} hat deine Enklave geplündert.",
  "world.toast.raidWon": "Überfall auf {name} erfolgreich.",
  "world.toast.raidLost": "Überfall auf {name} gescheitert.",
  "world.toast.boss": "Weltboss gesichtet bei {x},{y}!",
  "world.toast.scoutReport": "Spähbericht eingetroffen.",
  "social.tab.chat": "Chat",
  "social.tab.mail": "Post",
  "social.tab.boards": "Ranglisten",
  "social.tab.neighbours": "Nachbarn",
  "social.chat.global": "Global",
  "social.chat.system": "System",
  "social.chat.older": "Ältere Nachrichten laden",
  "social.chat.empty": "Noch nichts gesagt. Sag Hallo.",
  "social.chat.systemReadOnly": "Der Systemkanal ist nur lesbar: Ankündigungen, Bossmeldungen, erste S-Fabrikationen.",
  "social.chat.placeholder": "Nachricht … (@Name, x,y, :emote:)",
  "social.chat.mutedUntil": "Du bist stummgeschaltet.",
  "social.chat.emotes": "Emotes",
  "social.chat.emoteLocked": "Funkturm Stufe {n}",
  "social.chat.reply": "Antworten",
  "social.chat.report": "Melden",
  "social.chat.reported": "Gemeldet.",
  "social.chat.block": "Blockieren",
  "social.chat.blocked": "Blockiert.",
  "social.chat.delete": "Löschen",
  "social.chat.timeout": "10 min Timeout",
  "social.chat.muted": "Stummgeschaltet.",
  "social.chat.battleCard": "Kampfbericht",
  "social.chat.conversations": "Chats",
  "social.chat.retention": "Nachrichten verschwinden nach {h} h",
  "social.chat.dmKept": "Privat · bleibt erhalten",
  "social.chat.new": "{n} neu",
  "social.chat.unreadDivider": "{n} ungelesen",
  "social.chat.today": "Heute",
  "social.chat.yesterday": "Gestern",
  "social.chat.back": "Zurück zu den Chats",
  "social.chat.noMessages": "Noch keine Nachrichten",
  "social.chat.you": "Du: ",
  "social.chat.unitCard": "Einheit",
  "social.chat.deleted": "[gelöscht]",
  "social.mail.kind.all": "Alle",
  "social.mail.kind.system": "System",
  "social.mail.kind.battle": "Kampf",
  "social.mail.kind.reward": "Belohnung",
  "social.mail.kind.receipt": "Quittung",
  "social.mail.kind.admin": "Admin",
  "social.mail.trash": "Papierkorb",
  "social.mail.filter.all": "Alle",
  "social.mail.filter.battle": "Kämpfe",
  "social.mail.filter.reward": "Belohnungen",
  "social.mail.filter.system": "System",
  "social.mail.readAll": "Alle gelesen",
  "social.mail.readAllDone": "Alle Nachrichten als gelesen markiert.",
  "social.mail.deleteRead": "Gelesene löschen",
  "social.mail.pin": "Behalten",
  "social.mail.unpin": "Nicht mehr behalten",
  "social.mail.pinned": "Nachricht wird behalten.",
  "social.mail.unpinned": "Nachricht wird nicht mehr behalten.",
  "social.mail.watch": "Ansehen",
  "social.mail.capacityHint": "Bei vollem Postfach weicht die älteste ungelesene oder abgeholte Nachricht; {pinned} behaltene Nachrichten bleiben.",
  "social.mail.claimAll": "Alles abholen",
  "social.mail.claim": "Abholen",
  "social.mail.claimed": "Belohnung abgeholt.",
  "social.mail.claimedBadge": "abgeholt",
  "social.mail.empty": "Kein Posteingang.",
  "social.mail.delete": "Löschen",
  "social.mail.restore": "Wiederherstellen",
  "social.boards.live": "Aktuell",
  "social.boards.empty": "Noch keine Einträge.",
  "social.neighbours.title": "Nachbarn (15 Felder)",
  "social.neighbours.none": "Niemand in der Nähe.",
  "social.neighbours.idle": "Baut gerade nichts.",
  "social.neighbours.assisted": "Geholfen: −60 s.",
  "social.contacts.title": "Kontakte",
  "social.contacts.none": "Noch keine Kontakte.",
  "social.profile.message": "Nachricht",
  "social.profile.assist": "Helfen",
  "social.profile.attack": "Angreifen",
  "social.profile.contactAdd": "Kontakt",
  "social.profile.contactRemove": "Kontakt entfernen",
  "social.profile.block": "Blockieren",
  "social.profile.unblock": "Block aufheben",
  "social.profile.edit": "Profil bearbeiten",
  "social.profile.avatar": "Avatar",
  "social.profile.frame": "Rahmen",
  "social.profile.title": "Titel",
  "social.profile.colour": "Farbe",
  "social.profile.showcase": "Vorzeigetrupp",
  "social.profile.comms": "Funkturm {n}",
  "social.profile.kills": "Abschüsse",
  "social.profile.raids": "Überfälle",
  "social.profile.defences": "Verteidigt",
  "social.profile.arena": "Arena",
  "social.profile.founded": "Gegründet {date}",
  "social.lastSeen.online": "online",
  "social.lastSeen.minutes": "vor {n} min",
  "social.lastSeen.hours": "vor {n} h",
  "social.lastSeen.days": "{n, plural, one {vor # Tag} other {vor # Tagen}}",
  "social.lastSeen.never": "nie gesehen",
  "settings.social": "Soziales",
  "settings.blocked": "Blockierte Spieler",
  "settings.blocked.none": "Niemand blockiert.",
  "settings.chat.mentions": "Bei Erwähnungen benachrichtigen",
  "settings.chat.mail": "Bei neuer Post benachrichtigen",
  "settings.export": "Datenexport (JSON)",
  "settings.export.hint": "Alles, was der Server über dein Konto weiß, als Datei.",
  "settings.export.download": "Herunterladen",
  "settings.delete": "Konto löschen",
  "settings.delete.hint": "7 Tage Frist, danach wird das Konto anonymisiert. Bis dahin kannst du abbrechen.",
  "settings.delete.request": "Löschung beantragen",
  "settings.delete.pending": "Löschung fällig am {date}",
  "settings.delete.cancel": "Löschung abbrechen",
  "settings.delete.confirm": "Konto wirklich löschen? Nach 7 Tagen ist es weg.",
  "settings.ledger": "Credit-Buch",
  "settings.ledger.hint": "Jede Buchung, nichts verschwindet.",
  "settings.ledger.more": "Mehr",
  "common.claim": "Abholen",
  "store.credits": "Credits",
  "store.vipPoints": "VIP-Punkte",
  "store.hours": "≈ {n} h Spielzeit",
  "store.minutes": "≈ {n} min Spielzeit",
  "store.chainStep": "Kettenangebot · Schritt {n}",
  "store.limit": "{used}/{max} gekauft",
  "store.worth": "Wert ≈ {n} ₵",
  "store.notEnough": "Nicht genug Credits",
  "store.locked": "Gesperrt",
  "store.soldOut": "Ausverkauft",
  "store.doubleHint": "Erster Kauf des Monats: doppelter Inhalt!",
  "store.confirmHint": "Du bekommst sofort:",
  "store.balance": "Guthaben: {n} ₵",
  "store.fx.title": "Geliefert!",
  "store.fx.double": "Doppelt geliefert!",
  "store.fx.next": "Schritt {n} freigeschaltet: {price} ₵",
  "store.toast.vip": "+{n} VIP-Punkte",
  "store.push.flash": "Blitzangebot im Store!",
  "store.push.offer": "Kettenangebot Schritt {step}: {price} ₵",
  "store.push.vip": "VIP {level} erreicht!",
  "store.push.megavip": "MegaVIP Rang {rank}!",
  "store.push.doubles": "Neuer Monat: alle Paket-Doppler sind wieder da.",
  "store.section.chains": "Deine Kettenangebote",
  "store.chains.hint": "Drei Schritte, 24 Stunden pro Schritt – jeder Kauf schaltet den nächsten frei.",
  "store.section.flash": "Blitzangebote",
  "store.section.featured": "Empfohlen",
  "store.recommended.hint": "Passt zu deinem größten Engpass.",
  "store.section.mustbuy": "Pflichtkauf, Woche, Monat",
  "store.tab.featured": "Highlights",
  "store.tab.packs": "Pakete",
  "store.tab.daily": "Tagesangebote",
  "store.tab.passes": "Pässe",
  "store.tab.speedups": "Beschleuniger",
  "store.tab.resources": "Ressourcen",
  "store.tab.fabrication": "Fabrikation",
  "store.tab.vip": "VIP",
  "store.tab.lucky": "Glück",
  "store.tab.cosmetics": "Kosmetik",
  "store.tab.shops": "Shops",
  "store.packs.hint": "Der erste Kauf jeder Stufe im Monat liefert doppelt.",
  "store.packs.refreshed": "Neuer Monat – alle Doppler sind wieder aktiv!",
  "store.daily.rerolled": "Neue Tagesangebote",
  "store.daily.refreshFree": "Neu würfeln (gratis)",
  "store.daily.refreshPaid": "Neu würfeln ({n} ₵)",
  "store.daily.resets": "Neue Angebote in",
  "store.pass.claimed": "Abgeholt",
  "store.pass.days": "{n, plural, one {# Tag} other {# Tage}}",
  "store.pass.untilHq": "Bis HQ 25",
  "store.pass.active": "Aktiv",
  "store.perk.queue_build_2": "Zweite Bauwarteschlange",
  "store.perk.xp__10": "+10 % Einheiten-XP",
  "store.perk.frame": "Rahmen: {v}",
  "store.perk.track_premium": "Premium-Spur mit allen Stufenbelohnungen",
  "store.perk.drip": "{n} ₵ pro Tag",
  "store.perk.payouts": "{n} ₵ Auszahlungen bei HQ-Stufen",
  "store.perk.milestones": "{n} Meilensteintruhen",
  "store.pass.drip": "Tag {day} abholen",
  "store.pass.payout": "HQ {hq} auszahlen",
  "store.pass.milestone": "Meilenstein {n}",
  "store.pass.track.free": "Gratis-Spur",
  "store.pass.track.premium": "Premium-Spur",
  "store.pass.track.premium_plus": "Premium+ mit Saison-Skin",
  "store.pass.plus": "Premium+",
  "store.pass.tier": "Stufe {tier}/{max}",
  "store.pass.buyTier": "Stufe kaufen ({n} ₵)",
  "store.pass.tierBought": "Stufe gekauft",
  "store.pass.battle": "Battle Pass",
  "store.vip.chestClaimed": "VIP-Truhe abgeholt",
  "store.vip.points": "{n} / {next} Punkte",
  "store.vip.production": "Produktion",
  "store.vip.build": "Bautempo",
  "store.vip.units": "Einheitenwerte",
  "store.vip.streak": "Login-Serie {n}",
  "store.vip.chest": "Tägliche VIP-Truhe",
  "store.vip.chestLocked": "Ab VIP 1",
  "store.vip.unlocks": "Freigeschaltet",
  "store.vip.mega": "MegaVIP",
  "store.vip.megaHint": "Nach VIP 20 geht es endlos weiter: +1 % Einheitenwerte pro Rang.",
  "store.vip.shop": "VIP-Shop",
  "store.vip.shopHint": "Rabatte bis 80 %, Limits pro Woche.",
  "store.unlock.daily_chest": "Tägliche VIP-Truhe",
  "store.unlock.vip_shop": "VIP-Shop",
  "store.unlock.collect_all": "Alles einsammeln",
  "store.unlock.bookmarks_30": "30 Lesezeichen",
  "store.unlock.free_featured_weekly": "Wöchentlicher Featured-Zug gratis",
  "store.unlock.queue_build_2": "Zweite Bauwarteschlange",
  "store.unlock.arena_attempts__2": "+2 Arena-Versuche",
  "store.unlock.presets_5": "5 Formations-Presets",
  "store.unlock.unit": "Einheit: {v}",
  "store.unlock.layouts_5": "5 Basis-Layouts",
  "store.unlock.queue_research_2": "Zweite Forschungswarteschlange",
  "store.unlock.stamina_cap__20": "+20 Treibstoff-Limit",
  "store.unlock.march_speed__10": "+10 % Marschtempo",
  "store.unlock.queue_build_3": "Dritte Bauwarteschlange",
  "store.unlock.repair_slots__1": "+1 Reparaturplatz",
  "store.unlock.name_gold": "Goldener Name",
  "store.unlock.gather_speed__15": "+15 % Sammeltempo",
  "store.unlock.skin": "Skin: {v}",
  "store.unlock.fabrication_discount_10": "10 % Fabrikationsrabatt",
  "store.unlock.chest_gold_daily": "Goldtruhe täglich",
  "store.unlock.megavip": "MegaVIP-Leiter",
  "store.lucky.wheel": "Glücksrad",
  "store.lucky.vault": "Schicksalstresor",
  "store.lucky.discount": "Glücks-Rabatt",
  "store.lucky.capsules": "Kapselautomat",
  "store.lucky.jackpot": "Jackpot {n} ₵",
  "store.lucky.spinFree": "Gratis drehen",
  "store.lucky.spin": "Drehen ({n} ₵)",
  "store.lucky.odds": "Gewinnchancen",
  "store.lucky.shotsBought": "{n} Schüsse gekauft",
  "store.lucky.round": "Runde {n}",
  "store.lucky.treasure": "Schatzrunde ×3",
  "store.lucky.shots": "{n} Schüsse",
  "store.lucky.grandWithin": "Hauptpreis garantiert in den ersten {n}",
  "store.lucky.buyShots": "{n} Schüsse ({price} ₵)",
  "store.lucky.shoot": "{n}× schießen",
  "store.lucky.discountHint": "Garantierte Gutscheine bei Ziehung {at}.",
  "store.lucky.draws": "{n} Ziehungen",
  "store.lucky.draw": "Ziehen ({n} ₵)",
  "store.lucky.noCoupons": "Keine Gutscheine",
  "store.lucky.discountShop": "Rabatt-Shop",
  "store.lucky.capsuleHint": "Farbige Kapseln geben Schlüssel – {n} Minuten gültig.",
  "store.lucky.chest.green": "Grüne Truhe",
  "store.lucky.chest.blue": "Blaue Truhe",
  "store.lucky.chest.purple": "Lila Truhe",
  "store.lucky.chest.gold": "Goldtruhe",
  "store.lucky.capsuleFree": "Ziehen (gratis, {n})",
  "store.lucky.capsule": "Ziehen ({n} ₵)",
  "store.shop.bought": "Gekauft",
  "store.shop.refresh.daily": "Täglich neu",
  "store.shop.refresh.weekly": "Wöchentlich neu",
  "store.shop.refresh.event": "Pro Event",
  "store.cos.equipped": "Angelegt",
  "store.cos.unequipped": "Abgelegt",
  "store.cos.equip": "Anlegen",
  "store.cos.unequip": "Ablegen",
  "store.cos.reward": "Belohnung",
  "store.cos.previewFailed": "Die 3D-Vorschau konnte nicht geladen werden.",
  "store.cos.bonus.production": "Produktion",
  "store.cos.bonus.hp": "Lebenspunkte",
  "store.cos.kind.building_skin": "Gebäude",
  "store.cos.kind.unit_skin": "Einheiten",
  "store.cos.kind.base_skin": "Basis",
  "store.cos.kind.frame": "Rahmen",
  "store.cos.kind.name_colour": "Namensfarbe",
  "store.cos.kind.chat_bubble": "Sprechblasen",
  "store.cos.kind.emote_pack": "Emotes",
  "store.cos.kind.march_trail": "Marschspuren",
  "store.cos.kind.stinger": "Fanfaren",
  "events.tab.plaza": "Live",
  "events.tab.daily": "Täglich",
  "events.tab.growth": "Wachstum",
  "events.tab.achievements": "Erfolge",
  "events.tab.pass": "Battle Pass",
  "events.tab.calendar": "Kalender",
  "events.tab.progress": "Fortschritt",
  "events.rewards.ready": "{n} Belohnungen bereit",
  "events.rewards.readyOne": "1 Belohnung bereit",
  "events.rewards.claimAll": "Alles abholen",
  "events.rewards.claimed": "{n} Belohnungen abgeholt",
  "events.hunt.live": "Jagd läuft",
  "events.hunt.next": "Nächste Jagd",
  "events.hunt.targets": "{n}/{m} Ziele",
  "events.none": "Gerade läuft kein Event – schau in den Kalender.",
  "events.points": "{n} Punkte",
  "events.howto": "Wie bekomme ich Punkte?",
  "events.tokens": "{n} Event-Marken pro 100 Punkte",
  "events.ranking": "Rangliste",
  "events.ranking.empty": "Noch keine Punkte – sei der Erste.",
  "events.items": "Gegenstände",
  "events.shop": "Event-Shop",
  "events.toast.milestone": "Meilenstein abgeholt",
  "events.siege.title": "Belagerung: {n} Wellen",
  "events.siege.done": "{n} von {waves} Wellen überstanden",
  "events.siege.fight": "Wellen abwehren",
  "events.trial.title": "Stockwerk {floor} / {floors}",
  "events.trial.hint": "{n} Treibstoff pro Stockwerk, Truhe alle 10.",
  "events.trial.cleared": "Turm geschafft",
  "events.trial.climb": "Nächstes Stockwerk",
  "events.relics.title": "Relikttresore",
  "events.relics.held": "Gehalten von {name}",
  "events.relics.free": "Unbesetzt",
  "events.relics.guard": "Wächter Stufe {level}",
  "events.relics.take": "Erobern",
  "events.relics.mine": "Deins",
  "events.modifier.manufacturer_bonus": "Hersteller {d}: +{v} % Werte",
  "events.modifier.node_yield": "Feldausbeute ×{v}",
  "events.modifier.salvage_double": "Bergung ×{v}",
  "events.modifier.map_fog": "Kartenmodifikator: {v}",
  "events.daily.login": "Login-Kalender",
  "events.daily.streak": "Serie: {n} Tage",
  "events.daily.claimDay": "Tag {n} abholen",
  "events.daily.claimed": "Heute abgeholt",
  "events.daily.day": "Tag {n}",
  "events.daily.day28": "Monatstruhe am {day}.",
  "events.daily.missions": "Tagesaufträge {done}/{total}",
  "events.daily.dawn": "Dawn-Protokoll",
  "events.daily.dawnHint": "Punkte aus Aufklärung, Training, Abschüssen, Arena und Reparaturen.",
  "events.daily.intel": "Intel-Hub",
  "events.daily.intelHint": "Alle sechs Stunden neue Missionen, Lager {n}.",
  "events.daily.intelMinutes": "{n, plural, one {# Minute} other {# Minuten}}",
  "events.daily.intelStart": "Starten",
  "events.pass.missions": "Pass-Aufträge heute",
  "events.pass.weekly": "Diese Woche",
  "events.pass.hint": "Punkte aus täglichen und wöchentlichen Aufträgen; 100 Punkte pro Stufe.",
  "events.toast.login": "Login-Belohnung abgeholt",
  "events.toast.day28": "Monatstruhe abgeholt",
  "events.toast.intelStarted": "Mission gestartet",
  "events.toast.intelClaimed": "Mission abgeschlossen",
  "events.toast.growth": "Auftrag abgeholt",
  "events.toast.chapter": "Kapiteltruhe abgeholt",
  "events.toast.achievement": "Erfolg abgeholt",
  "events.growth.chapter": "Kapitel {n}: {name}",
  "events.growth.chest": "Kapiteltruhe",
  "events.growth.done": "Alle Kapitel abgeschlossen.",
  "events.growth.go": "Hin",
  "events.ach.building": "Bauen",
  "events.ach.units": "Einheiten",
  "events.ach.combat": "Kampf",
  "events.ach.world": "Welt",
  "events.ach.store": "Store",
  "events.ach.social": "Soziales",
  "events.ach.titles": "{n} Titel freigeschaltet",
  "events.ach.title": "Titel: {title}",
  "events.ach.frame": "Rahmen: {frame}",
  "events.calendar.upcoming": "Demnächst",
  "events.calendar.none": "Nichts geplant.",
  "events.push.start": "Ein Event hat begonnen!",
  "events.push.phase": "Neue Event-Phase",
  "events.push.end": "Ein Event ist vorbei – Belohnungen kommen per Post.",
  "events.push.newDay": "Neuer Tag: Aufträge und Truhen sind zurück.",
  "events.push.milestone": "Meilenstein erreicht!",
  "events.push.mission": "Auftrag erledigt (+{n})",
  "events.push.drip": "Dein Pass hat eine Tagesbelohnung für dich.",
  "events.today": "Heute",
  "events.source.build_level": "Gebäudestufen",
  "events.source.research_level": "Forschungen",
  "events.source.unit_level": "Einheitenstufen",
  "events.source.workshop_pull": "Fabrikationen",
  "events.source.pack_kill": "Rudel vernichtet",
  "events.source.elite_kill": "Eliten erlegt",
  "events.source.hive_damage": "Hive-Schaden",
  "events.source.boss_damage": "Boss-Schaden",
  "events.source.gather": "Ressourcen gesammelt",
  "events.source.stamina_spent": "Treibstoff ausgegeben",
  "events.source.credits_spent": "Credits ausgegeben",
  "events.source.raid_win": "Überfälle gewonnen",
  "events.source.defence": "Verteidigungen",
  "events.source.assist": "Nachbarn geholfen",
  "events.source.chat": "Chat-Nachrichten",
  "events.source.arena_win": "Arenasiege",
  "events.source.arena_fight": "Arenakämpfe",
  "events.source.expedition_clear": "Expeditionsstufen",
  "events.source.siege_wave": "Belagerungswellen",
  "events.source.login": "Logins",
  "events.source.mail_claim": "Post abgeholt",
  "events.source.repair": "Reparaturen",
  "events.source.mission_daily": "Tagesaufträge",
  "events.source.store_buy": "Käufe",
  "events.source.intel": "Intel-Missionen",
  "events.source.ruin": "Ruinen erkundet",
  "events.source.relic_hold": "Relikt-Stunden",
  "settings.notifications": "Benachrichtigungen",
  "settings.audio": "Klang und Musik",
  "settings.audio.hint": "Musik und Effekte lassen sich getrennt einstellen. Bauzeiten, Produktion und Märsche laufen auf dem Server auch bei geschlossenem Tab weiter.",
  "settings.audio.background": "Musik im Hintergrund weiterspielen",
  "settings.audio.background.hint": "Nach dem ersten Klick bleibt die Musik auch beim Tabwechsel an. Effekte pausieren. Bei Abmeldung oder geschlossener Seite endet der Ton.",
  "settings.announcements": "Globale Meldungen anzeigen",
  "settings.announcements.hint": "GM-Meldungen, seltene Funde und Weltboss-Sichtungen als Ticker. Im Systemchat bleiben sie nachlesbar.",
  "social.gm": "GM",
  "social.gm.title": "Game Master · geprüftes Serverkonto",
  "social.ticker.label": "Weltfunk",
  "social.ticker.open": "Meldung im Systemchat lesen",
  "social.ticker.next": "Nächste Meldung",
  "social.ticker.close": "Diese Meldung ausblenden",
  "settings.audio.sound": "Effekte und Umgebung",
  "settings.audio.music": "Musik",
  "settings.audio.mute": "Stumm",
  "settings.audio.unmute": "Ton an",
  "settings.audio.mute.sound": "Effekte stummschalten",
  "settings.audio.mute.music": "Musik stummschalten",
  "settings.audio.preview": "Klangvorschau abspielen",
  "settings.notifications.hint": "Ausgeschaltete Kategorien werden schon auf dem Server verworfen.",
  "settings.notif.build": "Bau fertig",
  "settings.notif.research": "Forschung fertig",
  "settings.notif.repair": "Reparatur fertig",
  "settings.notif.attack": "Angriffe",
  "settings.notif.march": "Märsche",
  "settings.notif.event": "Events und Aufträge",
  "settings.notif.chest": "Truhen bereit",
  "settings.notif.offer": "Angebote",
  "settings.notif.vip": "VIP",
  "world.assist": "Helfen",
  "world.assisted": "Nachbar unterstützt",
  "store.cos.previewName": "Koloniewache",
  "store.cos.previewMessage": "Willkommen daheim, Commander.",
  "store.cos.playSound": "Klang abspielen",
  "store.cos.stopSound": "Klang stoppen",
  "store.cos.soundMuted": "Ton stumm",
  "store.cos.packRequired": "Passendes Emote-Paket ausrüsten",
  "progression.gain": "Stärke +{n}",
  "progression.total": "Gesamtstärke",
  "progression.power.buildings": "Gebäude",
  "progression.power.research": "Forschung",
  "progression.power.units": "Einheiten",
  "progression.power.modules": "Module",
  "progression.power.drone": "Drohnen",
  "progression.powerHint": "Deine gesamte Sammlung zählt. Einsatz, Formation und Reparaturen senken diesen Wert nicht. Module werden einmal gezählt.",
  "progression.chapter": "Deine Kolonie wächst",
  "progression.hqLevel": "HQ Level {n}",
  "progression.subtitle": "Mehr Raum für Menschen, Maschinen und neue Ideen.",
  "progression.unlocked": "Jetzt verfügbar",
  "progression.earned": "Meilenstein erreicht",
  "progression.copy": "{name}: {n}. Bauplatz",
  "progression.zone": "{name} erschließen",
  "progression.collectAll": "Alle Produktionsbestände auf einmal sammeln",
  "progression.buildingCap": "Gebäude bis Level {n} ausbauen",
  "progression.titleAndFragment": "Neuer Profiltitel und {n} Basislack-Fragment",
  "progression.continue": "Weiterbauen",
  "progression.offers": "HQ-Festangebote ansehen",
  "progression.milestones": "HQ-Meilensteine",
  "progression.fragments": "Basislack-Fragmente {n}/{required}",
  "progression.fragmentHint": "Jeder Meilenstein gibt einmalig einen Titel und ein Fragment. {n} Fragmente ergeben eine Basislackierung deiner Wahl.",
  "progression.chooseSkin": "Basislackierung wählen",
  "progression.redeem": "Für {n} Fragmente freischalten",
  "progression.redeemConfirm": "Die Fragmente werden erst mit dieser Bestätigung verbraucht. Die Lackierung gehört danach dauerhaft dir.",
  "progression.skinGranted": "Basislackierung freigeschaltet",
  "progression.previewSkins": "Lackierungen im Store ansehen",
  "store.redesign.title": "Mehr für deinen nächsten Schritt",
  "store.redesign.subtitle": "Entdecke Vorräte, Verstärkung und Extras für deine Enklave.",
  "store.redesign.more": "Alle Kategorien",
  "store.redesign.limited": "Nur für begrenzte Zeit",
  "store.redesign.spotlight": "Jetzt im Fokus",
  "store.redesign.packsTitle": "Große Pläne. Passende Pakete.",
  "store.redesign.dailyTitle": "Dein heutiger Vorratsfund",
  "store.redesign.contents": "Alle Inhalte ansehen",
  "store.redesign.moreRewards": "{n} weitere Belohnungen",
  "store.redesign.choose": "Auswählen",
  "store.redesign.remaining": "Für dich noch {n}× kaufbar",
  "store.redesign.ends": "Endet in",
  "store.redesign.double": "Doppelte Inhalte",
  "store.redesign.standard": "Für deine Enklave",
  "events.redesign.title": "Dein nächstes Abenteuer",
  "events.redesign.subtitle": "Wähle ein Event. Entdecke dein nächstes Ziel und seine Belohnungen.",
  "events.redesign.active": "Jetzt aktiv",
  "events.redesign.upcoming": "Startet bald",
  "events.redesign.claimable": "Abholbar",
  "events.redesign.ended": "Beendet",
  "events.redesign.details": "Event ansehen",
  "events.redesign.nextReward": "Deine nächste Belohnung",
  "events.redesign.allRewards": "Alle Meilensteine",
  "events.redesign.ranking": "Rangliste und Preise",
  "events.redesign.starts": "Startet in",
  "events.redesign.ends": "Endet in",
  "events.redesign.dayEvents": "{n} Events",
  "events.redesign.agenda": "Dein Eventplan",
  "events.redesign.calendarHint": "Wähle einen Tag. Alle Zeiten gelten für Berlin.",
  "events.redesign.noDayEvents": "Für diesen Tag ist noch kein Event geplant.",
  "events.redesign.overview": "Übersicht",
  "events.redesign.availableRewards": "{n} Belohnungen warten",
  "nav.inventory": "Lager",
  "settings.gm": "Game Master",
  "settings.gm.open": "GM-Konsole öffnen",
  "inventory.title": "Mein Lager",
  "inventory.subtitle": "Dein Vorrat. Deine Verstärkung. Alles im Blick.",
  "inventory.refresh": "Lager aktualisieren",
  "inventory.overview": "Vorratsübersicht",
  "inventory.availableXp": "EXP zum Ausgeben",
  "inventory.xpBoxes": "in {n} Trainingskisten · Basis-EXP",
  "inventory.stackCount": "verschiedene Gegenstände",
  "inventory.resources": "Ressourcenvorrat",
  "inventory.capacityHint": "Produktionslager: {n} je Ressource, einschließlich noch nicht eingesammelter Produktion. Scrip ist unbegrenzt. Ungeöffnete Kisten zählen separat.",
  "inventory.pending": "Abholbereit: {n}",
  "inventory.sealed": "In Kisten: {n}",
  "inventory.items": "Gegenstände",
  "inventory.search": "Gegenstand suchen",
  "inventory.categories": "Gegenstandskategorien",
  "inventory.category.all": "Alle",
  "inventory.category.xp": "EXP",
  "inventory.category.resources": "Kisten",
  "inventory.category.speedups": "Beschleuniger",
  "inventory.category.recruitment": "Verstärkung",
  "inventory.category.equipment": "Ausrüstung",
  "inventory.category.boosts": "Einsatzhilfen",
  "inventory.category.tokens": "Marken",
  "inventory.category.other": "Weitere",
  "inventory.noMatches": "Keine Gegenstände für diese Auswahl.",
  "inventory.empty": "Dein Lager ist noch leer. Belohnungen landen hier, sobald du sie abholst.",
  "inventory.owned": "Im Besitz: {n}",
  "inventory.xpDetail": "{each} Basis-EXP je Kiste · insgesamt {total} EXP verfügbar. Boni werden bei der gewählten Einheit in der Vorschau berechnet.",
  "inventory.crateDetail": "Enthält {n} {resource} je Kiste. Dieser Vorrat ist noch nicht deinem Ressourcenkonto gutgeschrieben.",
  "inventory.speedupDetail": "Verkürzt einen passenden laufenden Auftrag um {n} Minuten je Gegenstand.",
  "inventory.xpHint": "Wähle eine Einheit und öffne dort das EXP-Training. Du siehst den Verbrauch und das Ergebnis vor der Bestätigung.",
  "inventory.useHint": "Wähle im nächsten Bereich die Einheit oder den Auftrag, für den du diesen Gegenstand einsetzen möchtest.",
  "inventory.chooseUnit": "Einheit zum Trainieren wählen",
  "inventory.openUse": "Zum Einsatzbereich",
  "inventory.storedHint": "Dieser Gegenstand bleibt in deinem Lager. Seine Verwendung ist vom jeweiligen Spielbereich abhängig.",
  "inventory.openResource": "{resource} und Gegenstände im Lager ansehen",
  "world.march.snapshotUnavailable": "Die Zusammensetzung dieses älteren Marsches wurde nicht aufgezeichnet.",
  "world.march.returnRoute": "Rückweg",
  "world.march.outboundRoute": "Marschroute",
  "world.march.modelRetry": "Truppmodelle erneut laden",
  "world.march.showColumn": "Trupp ansehen",
  "world.stamina.regen": "+1 alle {minutes} Min.",
  "world.stamina.next": "Nächster Punkt",
  "world.stamina.full": "Vorrat voll",
  "world.stamina.cost": "Kosten: {n} Treibstoff",
  "world.stamina.slots": "Märsche: {used}/{cap}",
  "inventory.used": "{n} {resource} gutgeschrieben.",
  "inventory.useQuantity": "Anzahl",
  "inventory.usePreview": "{qty} Gegenstände ergeben {n} {resource}.",
  "inventory.noOverflowLoss": "Es muss Platz für den gesamten Inhalt frei sein. Bei vollem Lager bleiben deine Gegenstände erhalten.",
  "inventory.refill": "{n}× Treibstoff auffüllen",
  "inventory.openCrates": "{n} Kisten öffnen",
  "base.error.STORAGE_FULL": "Dein Lager hat nicht genug Platz für den gesamten Kisteninhalt. Nutze erst Ressourcen oder vergrößere dein Lager.",
  "base.error.STAMINA_FULL": "Für diese Auffüllung ist dein Treibstoffvorrat zu voll. Setze erst Treibstoff ein.",
  "base.autoCollector.title": "Automatisch einsammeln",
  "base.autoCollector.description": "Sammelt alle 60 Sekunden deine Produktion ins Lager – auch wenn das Spiel geschlossen ist. Die Lagergrenzen bleiben bestehen.",
  "base.autoCollector.on": "Aktiviert",
  "base.autoCollector.off": "Ausgeschaltet",
  "base.autoCollector.locked": "Ab VIP 3 verfügbar. Du kannst weiterhin manuell einsammeln.",
  "base.autoCollector.next": "Nächste Sammlung:",
  "base.autoCollector.last": "Letzte Sammlung: {n} Ressourcen",
  "base.autoCollector.failed": "Die Einstellung konnte nicht gespeichert werden. Bitte erneut versuchen.",
  "inventory.storageAndCollection": "Lagergrenzen & Sammeln",

  "base.queue.freeBuilders": "{n} Bauleiter frei",
  "base.queue.occupied": "{used} von {slots} belegt",
  "base.queue.hireTitle": "Zusätzlichen Bauleiter mieten",
  "base.queue.expiresIn": "Mietzeit noch",
  "base.queue.hireCopy": "Ein zusätzlicher Platz lässt einen weiteren Auftrag gleichzeitig laufen. Wähle die Mietdauer.",
  "base.queue.extensionCopy": "Du verlängerst deinen bestehenden Mietplatz um die gewählte Dauer. Die Anzahl der Plätze bleibt dabei gleich.",
  "base.queue.rentAction": "Mietangebot öffnen",
  "base.queue.extendAction": "Verlängerung öffnen",
  "base.queue.noRenewal": "Einmaliger Preis in Spiel-Credits. Keine automatische Verlängerung.",
  "base.queue.maximum": "Alle dauerhaften Plätze sind freigeschaltet.",
  "base.queue.permanentUnlocks": "Dauerhaft freischalten",
  "base.queue.vipUnlock": "VIP {vip}: {n} dauerhafte Plätze",
  "base.queue.showVip": "VIP-Freischaltungen ansehen",
  "base.queue.explanation": "Ein Bauleiter betreut einen Bau oder Ausbau gleichzeitig. Öffne einen Auftrag, um ihn anzusehen oder zu beschleunigen.",
  "base.queue.expiredBusy": "Eine Miete ist abgelaufen. Laufende Aufträge werden fertig; neue Aufträge benötigen wieder einen freien Platz.",
  "base.queue.inspectJob": "Auftrag ansehen · Beschleunigen",
  "base.queue.empty": "Aktuell läuft kein Bauauftrag.",
  "base.queue.startBuilding": "Gebäude zum Bauen auswählen",
  "base.queue.fullHelp": "Alle Bauleiter sind beschäftigt. Du kannst einen Auftrag beschleunigen oder einen zusätzlichen Bauleiter mieten.",
  "base.queue.confirmExtend": "Mietplatz verlängern",
  "base.queue.confirmRent": "Zusätzlichen Platz mieten",
  "base.queue.confirmDescription": "{kind} · zusätzliche Mietdauer: {period}",
  "base.queue.creditStock": "Dein Vorrat: {n} Credits",
  "base.queue.creditShortage": "Für dieses Angebot fehlen dir noch Credits.",
  "base.queue.checkStatus": "Die Anfrage wurde nicht bestätigt. Der aktuelle Kontostand und die Mietzeit werden neu geladen. Prüfe den Status, bevor du erneut mietest.",
  "base.queue.backToStatus": "Zur Mietübersicht",
  "base.queue.pay": "Für {n} Credits bestätigen",
  "squad.entryTitle": "Dein Trupp zieht gemeinsam los",
  "squad.entryHint": "Stelle deine Einheiten auf: vier Kämpfer vorne, Kommandant und zwei Supports dahinter.",
  "squad.edit": "Trupp bearbeiten",
  "squad.create": "Trupp aufstellen",
  "squad.steps": "1. Platz wählen · 2. Einheit auswählen · 3. Auswahl übernehmen",
  "squad.filled": "{n}/7 Plätze belegt",
  "squad.state.checking": "Verfügbarkeit wird geprüft",
  "squad.state.deployed": "Unterwegs",
  "squad.state.reserved": "Für Belagerung reserviert",
  "squad.state.repairing": "Reparatur abwarten",
  "squad.state.ready": "Einsatzbereit",
  "squad.state.incomplete": "Noch nicht einsatzbereit",
  "squad.toExpeditions": "Auf Expedition schicken",
  "squad.toArena": "In die Arena",
  "squad.auto": "Automatisch aufstellen",
  "squad.autoHint": "Automatik belegt und speichert die Plätze mit deinen stärksten freien, intakten Einheiten.",
  "squad.choose": "Einheit wählen",
  "squad.front": "Front · 4 Kämpfer",
  "squad.frontHint": "Verteidiger, Angreifer und Saboteure stehen vorne. Normale Angriffe treffen zuerst diese Reihe.",
  "squad.rear": "Rückraum · Kommandant + 2 Supports",
  "squad.rearHint": "Dein Kommandant und die Unterstützung stehen hinter den Kämpfern. Bestimmte Fähigkeiten können sie direkt treffen.",
  "squad.missingCommander": "Kommandant fehlt: Du kannst bereits Kämpfer einsetzen. Ein Kommandant ergänzt Führung und Synergien.",
  "squad.repairHint": "Mindestens eine aufgestellte Einheit wird repariert. Warte auf die Reparatur oder ersetze sie für den nächsten Einsatz.",
  "squad.availabilityFailed": "Die Truppverfügbarkeit konnte nicht geladen werden. Prüfe sie erneut, bevor du die Aufstellung änderst.",
  "squad.deployedHint": "Dieser Trupp ist auf der Weltkarte unterwegs. Du kannst seine Einheiten ansehen und ihn nach der Rückkehr wieder ändern.",
  "squad.toWorld": "Zur Weltkarte",
  "squad.chemistryBonus": "Chemie +{n}%",
  "squad.inspect": "{name}: Details öffnen",
  "squad.pickerTitle": "{slot}: Einheit wählen",
  "squad.pickerHint": "Wähle eine Einheit und übernimm sie für diesen Platz. Abbrechen lässt die Aufstellung unverändert.",
  "squad.allowed": "Passende Rollen: {roles}",
  "squad.unitReserved": "Trupp {n} ist unterwegs oder reserviert",
  "squad.unassigned": "Frei verfügbar",
  "squad.selected": "Ausgewählt",
  "squad.selection": "Deine Auswahl: {name}",
  "squad.selectionEmpty": "Deine Auswahl: Platz leer lassen",
  "squad.transfer": "{name} wird aus Trupp {from} in Trupp {to} umgesetzt. Der bisherige Platz wird dabei frei.",
  "squad.moveSlot": "Die Einheit wird von {from} hierher umgesetzt. Ihr bisheriger Platz wird frei.",
  "squad.damagedHint": "Diese Einheit braucht Reparatur. Die Aufstellung kann gespeichert werden; für den Einsatz gelten weiterhin die Reparaturregeln.",
  "squad.changedReservation": "Die Verfügbarkeit hat sich geändert. Dieser Platz kann gerade nicht gespeichert werden.",
  "squad.apply": "Auswahl übernehmen",
  "squad.retry": "Verf?gbarkeit erneut pr?fen",
  "base.queue.builders": "Deine Bauleiter",
  "base.queue.fullPermanentHelp": "Alle Bauleiter sind beschäftigt. Öffne einen laufenden Auftrag, um ihn anzusehen oder zu beschleunigen.",
  "base.error.SQUAD_BUSY": "Dieser Trupp ist bereits unterwegs. Warte auf seine Rückkehr, bevor du die Aufstellung änderst.",
  "world.damage": "Schaden",
  "world.revengePrepare": "Rache vorbereiten",
  "world.revengeStart": "Rache starten",
  "world.revengeOnce": "Ein Gegenangriff. Der Bonus gilt bei Feindkontakt.",
  "world.revengeTooLate": "Dieser Trupp kommt erst nach Ablauf des Bonus an.",
  "world.revengeUnavailable": "Die Rache wurde bereits genutzt oder ist abgelaufen.",
  "world.revengeApplied": "Rachebonus des Angreifers: +{n}% Schaden. Für diesen Kampf verbraucht.",
  "base.error.REVENGE_EXPIRED": "Die Rache wurde bereits genutzt oder ist abgelaufen.",
  "base.error.REVENGE_PENDING": "Ein Rachetrupp ist bereits zu diesem Gegner unterwegs.",
  "base.error.REVENGE_TARGET": "Der Gegner ist umgezogen. Öffne die Rache erneut über den Bericht.",
  "base.error.REVENGE_TOO_LATE": "Der Rachebonus läuft vor der Ankunft deines Trupps ab.",
} as const;

export type MessageKey = keyof typeof de;
